const freeDomains = {
  "0-mail.com": 1,
  "027168.com": 1,
  "0815.su": 1,
  "0sg.net": 1,
  "10mail.org": 1,
  "10minutemail.co.za": 1,
  "11mail.com": 1,
  "123.com": 1,
  "123box.net": 1,
  "123india.com": 1,
  "123mail.cl": 1,
  "123mail.org": 1,
  "123qwe.co.uk": 1,
  "126.com": 1,
  "139.com": 1,
  "150mail.com": 1,
  "150ml.com": 1,
  "15meg4free.com": 1,
  "163.com": 1,
  "16mail.com": 1,
  "188.com": 1,
  "189.cn": 1,
  "1ce.us": 1,
  "1chuan.com": 1,
  "1coolplace.com": 1,
  "1freeemail.com": 1,
  "1funplace.com": 1,
  "1internetdrive.com": 1,
  "1mail.ml": 1,
  "1mail.net": 1,
  "1me.net": 1,
  "1mum.com": 1,
  "1musicrow.com": 1,
  "1netdrive.com": 1,
  "1nsyncfan.com": 1,
  "1pad.de": 1,
  "1under.com": 1,
  "1webave.com": 1,
  "1webhighway.com": 1,
  "1zhuan.com": 1,
  "2-mail.com": 1,
  "20email.eu": 1,
  "20mail.in": 1,
  "20mail.it": 1,
  "212.com": 1,
  "21cn.com": 1,
  "24horas.com": 1,
  "2911.net": 1,
  "2980.com": 1,
  "2bmail.co.uk": 1,
  "2d2i.com": 1,
  "2die4.com": 1,
  "2trom.com": 1,
  "3000.it": 1,
  "30minutesmail.com": 1,
  "3126.com": 1,
  "321media.com": 1,
  "33mail.com": 1,
  "37.com": 1,
  "3ammagazine.com": 1,
  "3dmail.com": 1,
  "3email.com": 1,
  "3g.ua": 1,
  "3mail.ga": 1,
  "3xl.net": 1,
  "444.net": 1,
  "4email.com": 1,
  "4email.net": 1,
  "4mg.com": 1,
  "4newyork.com": 1,
  "4warding.net": 1,
  "4warding.org": 1,
  "4x4man.com": 1,
  "50mail.com": 1,
  "60minutemail.com": 1,
  "6ip.us": 1,
  "6mail.cf": 1,
  "6paq.com": 1,
  "74.ru": 1,
  "7mail.ga": 1,
  "7mail.ml": 1,
  "88.am": 1,
  "8848.net": 1,
  "8mail.ga": 1,
  "8mail.ml": 1,
  "97rock.com": 1,
  "99experts.com": 1,
  "a45.in": 1,
  "aaamail.zzn.com": 1,
  "aamail.net": 1,
  "aapt.net.au": 1,
  "aaronkwok.net": 1,
  "abbeyroadlondon.co.uk": 1,
  "abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk.com": 1,
  "abcflash.net": 1,
  "abdulnour.com": 1,
  "aberystwyth.com": 1,
  "about.com": 1,
  "abusemail.de": 1,
  "abwesend.de": 1,
  "abyssmail.com": 1,
  "ac20mail.in": 1,
  "academycougars.com": 1,
  "acceso.or.cr": 1,
  "access4less.net": 1,
  "accessgcc.com": 1,
  "accountant.com": 1,
  "acdcfan.com": 1,
  "ace-of-base.com": 1,
  "acmemail.net": 1,
  "acninc.net": 1,
  "activist.com": 1,
  "adam.com.au": 1,
  "add3000.pp.ua": 1,
  "addcom.de": 1,
  "address.com": 1,
  "adelphia.net": 1,
  "adexec.com": 1,
  "adfarrow.com": 1,
  "adios.net": 1,
  "adoption.com": 1,
  "ados.fr": 1,
  "adrenalinefreak.com": 1,
  "advalvas.be": 1,
  "advantimo.com": 1,
  "aeiou.pt": 1,
  "aemail4u.com": 1,
  "aeneasmail.com": 1,
  "afreeinternet.com": 1,
  "africamail.com": 1,
  "africamel.net": 1,
  "ag.us.to": 1,
  "agoodmail.com": 1,
  "ahaa.dk": 1,
  "ahk.jp": 1,
  "aichi.com": 1,
  "aim.com": 1,
  "aircraftmail.com": 1,
  "airforce.net": 1,
  "airforceemail.com": 1,
  "airpost.net": 1,
  "ajacied.com": 1,
  "ajaxapp.net": 1,
  "ak47.hu": 1,
  "aknet.kg": 1,
  "albawaba.com": 1,
  "alex4all.com": 1,
  "alexandria.cc": 1,
  "algeria.com": 1,
  "alhilal.net": 1,
  "alibaba.com": 1,
  "alice.it": 1,
  "alive.cz": 1,
  "aliyun.com": 1,
  "allergist.com": 1,
  "allmail.net": 1,
  "alloymail.com": 1,
  "allracing.com": 1,
  "allsaintsfan.com": 1,
  "alpenjodel.de": 1,
  "alphafrau.de": 1,
  "alskens.dk": 1,
  "altavista.com": 1,
  "altavista.net": 1,
  "altavista.se": 1,
  "alternativagratis.com": 1,
  "alumni.com": 1,
  "alumnidirector.com": 1,
  "alvilag.hu": 1,
  "amail.com": 1,
  "amazonses.com": 1,
  "amele.com": 1,
  "america.hm": 1,
  "ameritech.net": 1,
  "amnetsal.com": 1,
  "amorki.pl": 1,
  "amrer.net": 1,
  "amuro.net": 1,
  "amuromail.com": 1,
  "ananzi.co.za": 1,
  "andylau.net": 1,
  "anfmail.com": 1,
  "angelfire.com": 1,
  "angelic.com": 1,
  "animail.net": 1,
  "animalhouse.com": 1,
  "animalwoman.net": 1,
  "anjungcafe.com": 1,
  "annsmail.com": 1,
  "ano-mail.net": 1,
  "anonmails.de": 1,
  "anonymous.to": 1,
  "anote.com": 1,
  "another.com": 1,
  "anotherdomaincyka.tk": 1,
  "anotherwin95.com": 1,
  "anti-social.com": 1,
  "antisocial.com": 1,
  "antispam24.de": 1,
  "antongijsen.com": 1,
  "antwerpen.com": 1,
  "anymoment.com": 1,
  "anytimenow.com": 1,
  "aol.com": 1,
  "aon.at": 1,
  "apexmail.com": 1,
  "apmail.com": 1,
  "apollo.lv": 1,
  "aport.ru": 1,
  "aport2000.ru": 1,
  "appraiser.net": 1,
  "approvers.net": 1,
  "arabia.com": 1,
  "arabtop.net": 1,
  "archaeologist.com": 1,
  "arcor.de": 1,
  "arcotronics.bg": 1,
  "arcticmail.com": 1,
  "argentina.com": 1,
  "aristotle.org": 1,
  "army.net": 1,
  "armyspy.com": 1,
  "arnet.com.ar": 1,
  "art-en-ligne.pro": 1,
  "artlover.com": 1,
  "artlover.com.au": 1,
  "as-if.com": 1,
  "asdasd.nl": 1,
  "asean-mail.com": 1,
  "asheville.com": 1,
  "asia-links.com": 1,
  "asia-mail.com": 1,
  "asiafind.com": 1,
  "asianavenue.com": 1,
  "asiancityweb.com": 1,
  "asiansonly.net": 1,
  "asianwired.net": 1,
  "asiapoint.net": 1,
  "ass.pp.ua": 1,
  "assala.com": 1,
  "assamesemail.com": 1,
  "astroboymail.com": 1,
  "astrolover.com": 1,
  "astrosfan.com": 1,
  "astrosfan.net": 1,
  "asurfer.com": 1,
  "atheist.com": 1,
  "athenachu.net": 1,
  "atina.cl": 1,
  "atl.lv": 1,
  "atlaswebmail.com": 1,
  "atmc.net": 1,
  "atozasia.com": 1,
  "atrus.ru": 1,
  "att.net": 1,
  "attglobal.net": 1,
  "attymail.com": 1,
  "au.ru": 1,
  "auctioneer.net": 1,
  "ausi.com": 1,
  "aussiemail.com.au": 1,
  "austin.rr.com": 1,
  "australia.edu": 1,
  "australiamail.com": 1,
  "austrosearch.net": 1,
  "autoescuelanerja.com": 1,
  "autograf.pl": 1,
  "autorambler.ru": 1,
  "aver.com": 1,
  "avh.hu": 1,
  "avia-tonic.fr": 1,
  "awsom.net": 1,
  "axoskate.com": 1,
  "ayna.com": 1,
  "azazazatashkent.tk": 1,
  "azimiweb.com": 1,
  "azmeil.tk": 1,
  "bachelorboy.com": 1,
  "bachelorgal.com": 1,
  "backpackers.com": 1,
  "backstreet-boys.com": 1,
  "backstreetboysclub.com": 1,
  "bagherpour.com": 1,
  "baldmama.de": 1,
  "baldpapa.de": 1,
  "ballyfinance.com": 1,
  "bangkok.com": 1,
  "bangkok2000.com": 1,
  "bannertown.net": 1,
  "baptistmail.com": 1,
  "baptized.com": 1,
  "barcelona.com": 1,
  "bareed.ws": 1,
  "bartender.net": 1,
  "baseballmail.com": 1,
  "basketballmail.com": 1,
  "batuta.net": 1,
  "baudoinconsulting.com": 1,
  "bboy.zzn.com": 1,
  "bcvibes.com": 1,
  "beddly.com": 1,
  "beeebank.com": 1,
  "beenhad.com": 1,
  "beep.ru": 1,
  "beer.com": 1,
  "beethoven.com": 1,
  "belice.com": 1,
  "belizehome.com": 1,
  "bell.net": 1,
  "bellair.net": 1,
  "bellsouth.net": 1,
  "berlin.com": 1,
  "berlin.de": 1,
  "berlinexpo.de": 1,
  "bestmail.us": 1,
  "betriebsdirektor.de": 1,
  "bettergolf.net": 1,
  "bharatmail.com": 1,
  "big1.us": 1,
  "bigassweb.com": 1,
  "bigblue.net.au": 1,
  "bigboab.com": 1,
  "bigfoot.com": 1,
  "bigfoot.de": 1,
  "bigger.com": 1,
  "biggerbadder.com": 1,
  "bigmailbox.com": 1,
  "bigmir.net": 1,
  "bigpond.au": 1,
  "bigpond.com": 1,
  "bigpond.com.au": 1,
  "bigpond.net": 1,
  "bigpond.net.au": 1,
  "bigramp.com": 1,
  "bigstring.com": 1,
  "bikemechanics.com": 1,
  "bikeracer.com": 1,
  "bikeracers.net": 1,
  "bikerider.com": 1,
  "billsfan.com": 1,
  "billsfan.net": 1,
  "bimla.net": 1,
  "bin-wieder-da.de": 1,
  "bio-muesli.info": 1,
  "birdlover.com": 1,
  "birdowner.net": 1,
  "bisons.com": 1,
  "bitmail.com": 1,
  "bitpage.net": 1,
  "bizhosting.com": 1,
  "bk.ru": 1,
  "blackburnmail.com": 1,
  "blackplanet.com": 1,
  "blader.com": 1,
  "bladesmail.net": 1,
  "blazemail.com": 1,
  "bleib-bei-mir.de": 1,
  "blockfilter.com": 1,
  "blogmyway.org": 1,
  "bluebottle.com": 1,
  "bluehyppo.com": 1,
  "bluemail.ch": 1,
  "bluemail.dk": 1,
  "bluesfan.com": 1,
  "bluewin.ch": 1,
  "blueyonder.co.uk": 1,
  "blushmail.com": 1,
  "blutig.me": 1,
  "bmlsports.net": 1,
  "boardermail.com": 1,
  "boatracers.com": 1,
  "bodhi.lawlita.com": 1,
  "bol.com.br": 1,
  "bolando.com": 1,
  "bollywoodz.com": 1,
  "boltonfans.com": 1,
  "bombdiggity.com": 1,
  "bonbon.net": 1,
  "boom.com": 1,
  "bootmail.com": 1,
  "bootybay.de": 1,
  "bornnaked.com": 1,
  "bostonoffice.com": 1,
  "boun.cr": 1,
  "bounce.net": 1,
  "bounces.amazon.com": 1,
  "bouncr.com": 1,
  "box.az": 1,
  "box.ua": 1,
  "boxbg.com": 1,
  "boxemail.com": 1,
  "boxformail.in": 1,
  "boxfrog.com": 1,
  "boximail.com": 1,
  "boyzoneclub.com": 1,
  "bradfordfans.com": 1,
  "brasilia.net": 1,
  "brazilmail.com": 1,
  "brazilmail.com.br": 1,
  "breadtimes.press": 1,
  "breathe.com": 1,
  "brennendesreich.de": 1,
  "bresnan.net": 1,
  "brew-master.com": 1,
  "brew-meister.com": 1,
  "brfree.com.br": 1,
  "briefemail.com": 1,
  "bright.net": 1,
  "britneyclub.com": 1,
  "brittonsign.com": 1,
  "broadcast.net": 1,
  "brokenvalve.com": 1,
  "brusseler.com": 1,
  "bsdmail.com": 1,
  "btcmail.pw": 1,
  "btconnect.co.uk": 1,
  "btconnect.com": 1,
  "btinternet.com": 1,
  "btopenworld.co.uk": 1,
  "buerotiger.de": 1,
  "buffymail.com": 1,
  "bullsfan.com": 1,
  "bullsgame.com": 1,
  "bumerang.ro": 1,
  "bumpymail.com": 1,
  "bund.us": 1,
  "burnthespam.info": 1,
  "burstmail.info": 1,
  "buryfans.com": 1,
  "business-man.com": 1,
  "businessman.net": 1,
  "busta-rhymes.com": 1,
  "buyersusa.com": 1,
  "bvimailbox.com": 1,
  "byom.de": 1,
  "c2.hu": 1,
  "c2i.net": 1,
  "c3.hu": 1,
  "c4.com": 1,
  "c51vsgq.com": 1,
  "cabacabana.com": 1,
  "cable.comcast.com": 1,
  "cableone.net": 1,
  "caere.it": 1,
  "cairomail.com": 1,
  "calendar-server.bounces.google.com": 1,
  "calidifontain.be": 1,
  "californiamail.com": 1,
  "callnetuk.com": 1,
  "callsign.net": 1,
  "caltanet.it": 1,
  "camidge.com": 1,
  "canada-11.com": 1,
  "canada.com": 1,
  "canadianmail.com": 1,
  "canoemail.com": 1,
  "canwetalk.com": 1,
  "caramail.com": 1,
  "care2.com": 1,
  "careerbuildermail.com": 1,
  "carioca.net": 1,
  "cartelera.org": 1,
  "cartestraina.ro": 1,
  "casablancaresort.com": 1,
  "casema.nl": 1,
  "cash4u.com": 1,
  "cashette.com": 1,
  "casino.com": 1,
  "catcha.com": 1,
  "catchamail.com": 1,
  "catholic.org": 1,
  "catlover.com": 1,
  "cd2.com": 1,
  "celineclub.com": 1,
  "celtic.com": 1,
  "center-mail.de": 1,
  "centermail.at": 1,
  "centermail.de": 1,
  "centermail.info": 1,
  "centoper.it": 1,
  "centralpets.com": 1,
  "centrum.cz": 1,
  "centrum.sk": 1,
  "centurytel.net": 1,
  "certifiedmail.com": 1,
  "cfl.rr.com": 1,
  "cgac.es": 1,
  "cghost.s-a-d.de": 1,
  "chacuo.net": 1,
  "chaiyomail.com": 1,
  "chammy.info": 1,
  "chance2mail.com": 1,
  "chandrasekar.net": 1,
  "charmedmail.com": 1,
  "charter.net": 1,
  "chat.ru": 1,
  "chattown.com": 1,
  "chauhanweb.com": 1,
  "cheatmail.de": 1,
  "chechnya.conf.work": 1,
  "check.com": 1,
  "check1check.com": 1,
  "cheerful.com": 1,
  "chef.net": 1,
  "chek.com": 1,
  "chello.nl": 1,
  "chemist.com": 1,
  "chequemail.com": 1,
  "cheyenneweb.com": 1,
  "chez.com": 1,
  "chickmail.com": 1,
  "china.com": 1,
  "china.net.vg": 1,
  "chinamail.com": 1,
  "chirk.com": 1,
  "chocaholic.com.au": 1,
  "chong-mail.com": 1,
  "chong-mail.net": 1,
  "churchusa.com": 1,
  "cia-agent.com": 1,
  "cia.hu": 1,
  "ciaoweb.it": 1,
  "cicciociccio.com": 1,
  "cincinow.net": 1,
  "cinci.rr.com": 1,
  "citiz.net": 1,
  "citlink.net": 1,
  "citromail.hu": 1,
  "city-of-bath.org": 1,
  "city-of-birmingham.com": 1,
  "city-of-brighton.org": 1,
  "city-of-cambridge.com": 1,
  "city-of-coventry.com": 1,
  "city-of-edinburgh.com": 1,
  "city-of-lichfield.com": 1,
  "city-of-lincoln.com": 1,
  "city-of-liverpool.com": 1,
  "city-of-manchester.com": 1,
  "city-of-nottingham.com": 1,
  "city-of-oxford.com": 1,
  "city-of-swansea.com": 1,
  "city-of-westminster.com": 1,
  "city-of-westminster.net": 1,
  "city-of-york.net": 1,
  "cityofcardiff.net": 1,
  "cityoflondon.org": 1,
  "ckaazaza.tk": 1,
  "claramail.com": 1,
  "classicalfan.com": 1,
  "classicmail.co.za": 1,
  "clear.net.nz": 1,
  "clearwire.net": 1,
  "clerk.com": 1,
  "cliffhanger.com": 1,
  "clixser.com": 1,
  "close2you.net": 1,
  "clrmail.com": 1,
  "club4x4.net": 1,
  "clubalfa.com": 1,
  "clubbers.net": 1,
  "clubducati.com": 1,
  "clubhonda.net": 1,
  "clubmember.org": 1,
  "clubnetnoir.com": 1,
  "clubvdo.net": 1,
  "cluemail.com": 1,
  "cmail.net": 1,
  "cmpmail.com": 1,
  "cnnsimail.com": 1,
  "cntv.cn": 1,
  "codec.ro": 1,
  "coder.hu": 1,
  "coid.biz": 1,
  "coldmail.com": 1,
  "collectiblesuperstore.com": 1,
  "collector.org": 1,
  "collegeclub.com": 1,
  "collegemail.com": 1,
  "colleges.com": 1,
  "columbus.rr.com": 1,
  "columbusrr.com": 1,
  "columnist.com": 1,
  "comcast.net": 1,
  "comic.com": 1,
  "communityconnect.com": 1,
  "comporium.net": 1,
  "comprendemail.com": 1,
  "compuserve.com": 1,
  "computer-freak.com": 1,
  "computer4u.com": 1,
  "computermail.net": 1,
  "conexcol.com": 1,
  "conk.com": 1,
  "connect4free.net": 1,
  "connectbox.com": 1,
  "consultant.com": 1,
  "consumerriot.com": 1,
  "contractor.net": 1,
  "contrasto.cu.cc": 1,
  "cookiemonster.com": 1,
  "cool.br": 1,
  "coole-files.de": 1,
  "coolgoose.ca": 1,
  "coolgoose.com": 1,
  "coolkiwi.com": 1,
  "coollist.com": 1,
  "coolmail.com": 1,
  "coolmail.net": 1,
  "coolsend.com": 1,
  "coolsite.net": 1,
  "cooooool.com": 1,
  "cooperation.net": 1,
  "cooperationtogo.net": 1,
  "copacabana.com": 1,
  "copper.net": 1,
  "cornells.com": 1,
  "cornerpub.com": 1,
  "corporatedirtbag.com": 1,
  "correo.terra.com.gt": 1,
  "cortinet.com": 1,
  "cotas.net": 1,
  "counsellor.com": 1,
  "countrylover.com": 1,
  "cox.com": 1,
  "cox.net": 1,
  "coxinet.net": 1,
  "cracker.hu": 1,
  "crapmail.org": 1,
  "crazedanddazed.com": 1,
  "crazymailing.com": 1,
  "crazysexycool.com": 1,
  "cristianemail.com": 1,
  "critterpost.com": 1,
  "croeso.com": 1,
  "crosshairs.com": 1,
  "crosswinds.net": 1,
  "crwmail.com": 1,
  "cry4helponline.com": 1,
  "cs.com": 1,
  "csinibaba.hu": 1,
  "cuemail.com": 1,
  "curio-city.com": 1,
  "curryworld.de": 1,
  "cute-girl.com": 1,
  "cuteandcuddly.com": 1,
  "cutey.com": 1,
  "cww.de": 1,
  "cyber-africa.net": 1,
  "cyber-innovation.club": 1,
  "cyber-matrix.com": 1,
  "cyber-phone.eu": 1,
  "cyber-wizard.com": 1,
  "cyber4all.com": 1,
  "cyberbabies.com": 1,
  "cybercafemaui.com": 1,
  "cyberdude.com": 1,
  "cyberforeplay.net": 1,
  "cybergal.com": 1,
  "cybergrrl.com": 1,
  "cyberinbox.com": 1,
  "cyberleports.com": 1,
  "cybermail.net": 1,
  "cybernet.it": 1,
  "cyberservices.com": 1,
  "cyberspace-asia.com": 1,
  "cybertrains.org": 1,
  "cyclefanz.com": 1,
  "cynetcity.com": 1,
  "dabsol.net": 1,
  "dadacasa.com": 1,
  "daha.com": 1,
  "dailypioneer.com": 1,
  "dallasmail.com": 1,
  "dangerous-minds.com": 1,
  "dansegulvet.com": 1,
  "dasdasdascyka.tk": 1,
  "data54.com": 1,
  "davegracey.com": 1,
  "dawnsonmail.com": 1,
  "dawsonmail.com": 1,
  "dazedandconfused.com": 1,
  "dbzmail.com": 1,
  "dcemail.com": 1,
  "deadlymob.org": 1,
  "deagot.com": 1,
  "deal-maker.com": 1,
  "dearriba.com": 1,
  "death-star.com": 1,
  "deliveryman.com": 1,
  "deneg.net": 1,
  "depechemode.com": 1,
  "deseretmail.com": 1,
  "desertmail.com": 1,
  "desilota.com": 1,
  "deskpilot.com": 1,
  "destin.com": 1,
  "detik.com": 1,
  "deutschland-net.com": 1,
  "devotedcouples.com": 1,
  "dezigner.ru": 1,
  "dfwatson.com": 1,
  "di-ve.com": 1,
  "die-besten-bilder.de": 1,
  "die-genossen.de": 1,
  "die-optimisten.de": 1,
  "die-optimisten.net": 1,
  "diemailbox.de": 1,
  "digibel.be": 1,
  "digital-filestore.de": 1,
  "diplomats.com": 1,
  "directbox.com": 1,
  "dirtracer.com": 1,
  "discard.email": 1,
  "discard.ga": 1,
  "discard.gq": 1,
  "disciples.com": 1,
  "discofan.com": 1,
  "discoverymail.com": 1,
  "disign-concept.eu": 1,
  "disign-revelation.com": 1,
  "disinfo.net": 1,
  "dispomail.eu": 1,
  "disposable.com": 1,
  "dispose.it": 1,
  "dm.w3internet.co.uk": 1,
  "dmailman.com": 1,
  "dnainternet.net": 1,
  "dnsmadeeasy.com": 1,
  "doclist.bounces.google.com": 1,
  "docmail.cz": 1,
  "docs.google.com": 1,
  "doctor.com": 1,
  "dodgit.org": 1,
  "dodo.com.au": 1,
  "dodsi.com": 1,
  "dog.com": 1,
  "dogit.com": 1,
  "doglover.com": 1,
  "dogmail.co.uk": 1,
  "dogsnob.net": 1,
  "doityourself.com": 1,
  "domforfb1.tk": 1,
  "domforfb2.tk": 1,
  "domforfb3.tk": 1,
  "domforfb4.tk": 1,
  "domforfb5.tk": 1,
  "domforfb6.tk": 1,
  "domforfb7.tk": 1,
  "domforfb8.tk": 1,
  "domozmail.com": 1,
  "doneasy.com": 1,
  "donjuan.com": 1,
  "dontgotmail.com": 1,
  "dontmesswithtexas.com": 1,
  "doramail.com": 1,
  "dostmail.com": 1,
  "dotcom.fr": 1,
  "dotmsg.com": 1,
  "dott.it": 1,
  "download-privat.de": 1,
  "dplanet.ch": 1,
  "dr.com": 1,
  "dragoncon.net": 1,
  "dropmail.me": 1,
  "dropzone.com": 1,
  "drotposta.hu": 1,
  "dubaimail.com": 1,
  "dublin.com": 1,
  "dublin.ie": 1,
  "dumpmail.com": 1,
  "dumpmail.de": 1,
  "dumpyemail.com": 1,
  "dunlopdriver.com": 1,
  "dunloprider.com": 1,
  "duno.com": 1,
  "duskmail.com": 1,
  "dutchmail.com": 1,
  "dwp.net": 1,
  "dygo.com": 1,
  "dynamitemail.com": 1,
  "dyndns.org": 1,
  "e-apollo.lv": 1,
  "e-mail.com.tr": 1,
  "e-mail.dk": 1,
  "e-mail.ru": 1,
  "e-mail.ua": 1,
  "e-mailanywhere.com": 1,
  "e-mails.ru": 1,
  "e-tapaal.com": 1,
  "earthalliance.com": 1,
  "earthcam.net": 1,
  "earthdome.com": 1,
  "earthling.net": 1,
  "earthlink.net": 1,
  "earthonline.net": 1,
  "eastcoast.co.za": 1,
  "eastmail.com": 1,
  "easy.to": 1,
  "easypost.com": 1,
  "easytrashmail.com": 1,
  "ec.rr.com": 1,
  "ecardmail.com": 1,
  "ecbsolutions.net": 1,
  "echina.com": 1,
  "ecolo-online.fr": 1,
  "ecompare.com": 1,
  "edmail.com": 1,
  "ednatx.com": 1,
  "edtnmail.com": 1,
  "educacao.te.pt": 1,
  "eelmail.com": 1,
  "ehmail.com": 1,
  "einrot.com": 1,
  "einrot.de": 1,
  "eintagsmail.de": 1,
  "eircom.net": 1,
  "elisanet.fi": 1,
  "elitemail.org": 1,
  "elsitio.com": 1,
  "elvis.com": 1,
  "elvisfan.com": 1,
  "email-fake.gq": 1,
  "email-london.co.uk": 1,
  "email.biz": 1,
  "email.cbes.net": 1,
  "email.com": 1,
  "email.cz": 1,
  "email.ee": 1,
  "email.it": 1,
  "email.nu": 1,
  "email.org": 1,
  "email.ro": 1,
  "email.ru": 1,
  "email.si": 1,
  "email.su": 1,
  "email.ua": 1,
  "email2me.net": 1,
  "email4u.info": 1,
  "emailacc.com": 1,
  "emailaccount.com": 1,
  "emailage.ga": 1,
  "emailage.gq": 1,
  "emailasso.net": 1,
  "emailchoice.com": 1,
  "emailcorner.net": 1,
  "emailem.com": 1,
  "emailengine.net": 1,
  "emailengine.org": 1,
  "emailer.hubspot.com": 1,
  "emailforyou.net": 1,
  "emailgo.de": 1,
  "emailgroups.net": 1,
  "emailinfive.com": 1,
  "emailit.com": 1,
  "emailpinoy.com": 1,
  "emailplanet.com": 1,
  "emailplus.org": 1,
  "emailproxsy.com": 1,
  "emails.ga": 1,
  "emails.incisivemedia.com": 1,
  "emails.ru": 1,
  "emailthe.net": 1,
  "emailto.de": 1,
  "emailuser.net": 1,
  "emailx.net": 1,
  "emailz.ga": 1,
  "emailz.gq": 1,
  "ematic.com": 1,
  "embarqmail.com": 1,
  "emeil.in": 1,
  "emeil.ir": 1,
  "emil.com": 1,
  "eml.cc": 1,
  "eml.pp.ua": 1,
  "end-war.com": 1,
  "enel.net": 1,
  "engineer.com": 1,
  "england.com": 1,
  "england.edu": 1,
  "englandmail.com": 1,
  "epage.ru": 1,
  "epatra.com": 1,
  "ephemail.net": 1,
  "epix.net": 1,
  "epost.de": 1,
  "eposta.hu": 1,
  "eqqu.com": 1,
  "eramail.co.za": 1,
  "eresmas.com": 1,
  "eriga.lv": 1,
  "estranet.it": 1,
  "ethos.st": 1,
  "etoast.com": 1,
  "etrademail.com": 1,
  "etranquil.com": 1,
  "etranquil.net": 1,
  "eudoramail.com": 1,
  "europamel.net": 1,
  "europe.com": 1,
  "europemail.com": 1,
  "euroseek.com": 1,
  "eurosport.com": 1,
  "every1.net": 1,
  "everyday.com.kh": 1,
  "everymail.net": 1,
  "everyone.net": 1,
  "everytg.ml": 1,
  "examnotes.net": 1,
  "excite.co.jp": 1,
  "excite.com": 1,
  "excite.it": 1,
  "execs.com": 1,
  "exemail.com.au": 1,
  "exg6.exghost.com": 1,
  "existiert.net": 1,
  "expressasia.com": 1,
  "extenda.net": 1,
  "extended.com": 1,
  "eyepaste.com": 1,
  "eyou.com": 1,
  "ezcybersearch.com": 1,
  "ezmail.egine.com": 1,
  "ezmail.ru": 1,
  "ezrs.com": 1,
  "f-m.fm": 1,
  "f1fans.net": 1,
  "facebook-email.ga": 1,
  "facebook.com": 1,
  "facebookmail.com": 1,
  "facebookmail.gq": 1,
  "fahr-zur-hoelle.org": 1,
  "fake-email.pp.ua": 1,
  "fake-mail.cf": 1,
  "fake-mail.ga": 1,
  "fake-mail.ml": 1,
  "fakemailz.com": 1,
  "falseaddress.com": 1,
  "fan.com": 1,
  "fansonlymail.com": 1,
  "fansworldwide.de": 1,
  "fantasticmail.com": 1,
  "farang.net": 1,
  "farifluset.mailexpire.com": 1,
  "faroweb.com": 1,
  "fast-email.com": 1,
  "fast-mail.fr": 1,
  "fast-mail.org": 1,
  "fastacura.com": 1,
  "fastchevy.com": 1,
  "fastchrysler.com": 1,
  "fastem.com": 1,
  "fastemail.us": 1,
  "fastemailer.com": 1,
  "fastermail.com": 1,
  "fastest.cc": 1,
  "fastimap.com": 1,
  "fastkawasaki.com": 1,
  "fastmail.ca": 1,
  "fastmail.cn": 1,
  "fastmail.co.uk": 1,
  "fastmail.com": 1,
  "fastmail.com.au": 1,
  "fastmail.es": 1,
  "fastmail.fm": 1,
  "fastmail.im": 1,
  "fastmail.in": 1,
  "fastmail.jp": 1,
  "fastmail.mx": 1,
  "fastmail.net": 1,
  "fastmail.nl": 1,
  "fastmail.se": 1,
  "fastmail.to": 1,
  "fastmail.tw": 1,
  "fastmail.us": 1,
  "fastmailbox.net": 1,
  "fastmazda.com": 1,
  "fastmessaging.com": 1,
  "fastmitsubishi.com": 1,
  "fastnissan.com": 1,
  "fastservice.com": 1,
  "fastsubaru.com": 1,
  "fastsuzuki.com": 1,
  "fasttoyota.com": 1,
  "fastyamaha.com": 1,
  "fatcock.net": 1,
  "fatflap.com": 1,
  "fathersrightsne.org": 1,
  "fax.ru": 1,
  "fbi-agent.com": 1,
  "fbi.hu": 1,
  "fdfdsfds.com": 1,
  "fea.st": 1,
  "federalcontractors.com": 1,
  "feinripptraeger.de": 1,
  "felicitymail.com": 1,
  "femenino.com": 1,
  "fetchmail.co.uk": 1,
  "fettabernett.de": 1,
  "feyenoorder.com": 1,
  "ffanet.com": 1,
  "fiberia.com": 1,
  "ficken.de": 1,
  "fightallspam.com": 1,
  "filipinolinks.com": 1,
  "financemail.net": 1,
  "financier.com": 1,
  "findmail.com": 1,
  "finebody.com": 1,
  "fire-brigade.com": 1,
  "fireman.net": 1,
  "fishburne.org": 1,
  "fishfuse.com": 1,
  "fixmail.tk": 1,
  "fizmail.com": 1,
  "flashbox.5july.org": 1,
  "flashmail.com": 1,
  "flashmail.net": 1,
  "fleckens.hu": 1,
  "flipcode.com": 1,
  "fmail.co.uk": 1,
  "fmailbox.com": 1,
  "fmgirl.com": 1,
  "fmguy.com": 1,
  "fnbmail.co.za": 1,
  "fnmail.com": 1,
  "folkfan.com": 1,
  "foodmail.com": 1,
  "footard.com": 1,
  "footballmail.com": 1,
  "foothills.net": 1,
  "for-president.com": 1,
  "force9.co.uk": 1,
  "forfree.at": 1,
  "forgetmail.com": 1,
  "fornow.eu": 1,
  "forpresident.com": 1,
  "fortuncity.com": 1,
  "fortunecity.com": 1,
  "forum.dk": 1,
  "foxmail.com": 1,
  "fr33mail.info": 1,
  "francemel.fr": 1,
  "free-email.ga": 1,
  "free-online.net": 1,
  "free-org.com": 1,
  "free.com.pe": 1,
  "free.fr": 1,
  "freeaccess.nl": 1,
  "freeaccount.com": 1,
  "freeandsingle.com": 1,
  "freedom.usa.com": 1,
  "freedomlover.com": 1,
  "freegates.be": 1,
  "freeghana.com": 1,
  "freelance-france.eu": 1,
  "freeler.nl": 1,
  "freemail.c3.hu": 1,
  "freemail.com.au": 1,
  "freemail.com.pk": 1,
  "freemail.de": 1,
  "freemail.et": 1,
  "freemail.gr": 1,
  "freemail.hu": 1,
  "freemail.it": 1,
  "freemail.lt": 1,
  "freemail.ms": 1,
  "freemail.nl": 1,
  "freemail.org.mk": 1,
  "freemails.ga": 1,
  "freemeil.gq": 1,
  "freenet.de": 1,
  "freenet.kg": 1,
  "freeola.com": 1,
  "freeola.net": 1,
  "freeserve.co.uk": 1,
  "freestart.hu": 1,
  "freesurf.fr": 1,
  "freesurf.nl": 1,
  "freeuk.com": 1,
  "freeuk.net": 1,
  "freeukisp.co.uk": 1,
  "freeweb.org": 1,
  "freewebemail.com": 1,
  "freeyellow.com": 1,
  "freezone.co.uk": 1,
  "fresnomail.com": 1,
  "freudenkinder.de": 1,
  "freundin.ru": 1,
  "friendlymail.co.uk": 1,
  "friends-cafe.com": 1,
  "friendsfan.com": 1,
  "from-africa.com": 1,
  "from-america.com": 1,
  "from-argentina.com": 1,
  "from-asia.com": 1,
  "from-australia.com": 1,
  "from-belgium.com": 1,
  "from-brazil.com": 1,
  "from-canada.com": 1,
  "from-china.net": 1,
  "from-england.com": 1,
  "from-europe.com": 1,
  "from-france.net": 1,
  "from-germany.net": 1,
  "from-holland.com": 1,
  "from-israel.com": 1,
  "from-italy.net": 1,
  "from-japan.net": 1,
  "from-korea.com": 1,
  "from-mexico.com": 1,
  "from-outerspace.com": 1,
  "from-russia.com": 1,
  "from-spain.net": 1,
  "fromalabama.com": 1,
  "fromalaska.com": 1,
  "fromarizona.com": 1,
  "fromarkansas.com": 1,
  "fromcalifornia.com": 1,
  "fromcolorado.com": 1,
  "fromconnecticut.com": 1,
  "fromdelaware.com": 1,
  "fromflorida.net": 1,
  "fromgeorgia.com": 1,
  "fromhawaii.net": 1,
  "fromidaho.com": 1,
  "fromillinois.com": 1,
  "fromindiana.com": 1,
  "fromiowa.com": 1,
  "fromjupiter.com": 1,
  "fromkansas.com": 1,
  "fromkentucky.com": 1,
  "fromlouisiana.com": 1,
  "frommaine.net": 1,
  "frommaryland.com": 1,
  "frommassachusetts.com": 1,
  "frommiami.com": 1,
  "frommichigan.com": 1,
  "fromminnesota.com": 1,
  "frommississippi.com": 1,
  "frommissouri.com": 1,
  "frommontana.com": 1,
  "fromnebraska.com": 1,
  "fromnevada.com": 1,
  "fromnewhampshire.com": 1,
  "fromnewjersey.com": 1,
  "fromnewmexico.com": 1,
  "fromnewyork.net": 1,
  "fromnorthcarolina.com": 1,
  "fromnorthdakota.com": 1,
  "fromohio.com": 1,
  "fromoklahoma.com": 1,
  "fromoregon.net": 1,
  "frompennsylvania.com": 1,
  "fromrhodeisland.com": 1,
  "fromru.com": 1,
  "fromsouthcarolina.com": 1,
  "fromsouthdakota.com": 1,
  "fromtennessee.com": 1,
  "fromtexas.com": 1,
  "fromthestates.com": 1,
  "fromutah.com": 1,
  "fromvermont.com": 1,
  "fromvirginia.com": 1,
  "fromwashington.com": 1,
  "fromwashingtondc.com": 1,
  "fromwestvirginia.com": 1,
  "fromwisconsin.com": 1,
  "fromwyoming.com": 1,
  "front.ru": 1,
  "frontier.com": 1,
  "frontiernet.net": 1,
  "frostbyte.uk.net": 1,
  "fsmail.net": 1,
  "ftc-i.net": 1,
  "ftml.net": 1,
  "fullmail.com": 1,
  "funkfan.com": 1,
  "fuorissimo.com": 1,
  "furnitureprovider.com": 1,
  "fuse.net": 1,
  "fut.es": 1,
  "fux0ringduh.com": 1,
  "fwnb.com": 1,
  "fxsmails.com": 1,
  "galaxy5.com": 1,
  "galaxyhit.com": 1,
  "gamebox.net": 1,
  "gamegeek.com": 1,
  "gamespotmail.com": 1,
  "gamno.config.work": 1,
  "garbage.com": 1,
  "gardener.com": 1,
  "gawab.com": 1,
  "gaybrighton.co.uk": 1,
  "gaza.net": 1,
  "gazeta.pl": 1,
  "gazibooks.com": 1,
  "gci.net": 1,
  "geecities.com": 1,
  "geek.com": 1,
  "geek.hu": 1,
  "geeklife.com": 1,
  "gelitik.in": 1,
  "gencmail.com": 1,
  "general-hospital.com": 1,
  "gentlemansclub.de": 1,
  "geocities.com": 1,
  "geography.net": 1,
  "geologist.com": 1,
  "geopia.com": 1,
  "germanymail.com": 1,
  "get.pp.ua": 1,
  "get1mail.com": 1,
  "getairmail.cf": 1,
  "getairmail.com": 1,
  "getairmail.ga": 1,
  "getairmail.gq": 1,
  "getonemail.net": 1,
  "ghanamail.com": 1,
  "ghostmail.com": 1,
  "ghosttexter.de": 1,
  "giga4u.de": 1,
  "gigileung.org": 1,
  "girl4god.com": 1,
  "givepeaceachance.com": 1,
  "glay.org": 1,
  "glendale.net": 1,
  "globalfree.it": 1,
  "globalpagan.com": 1,
  "globalsite.com.br": 1,
  "gmail.com": 1,
  "gmail.com.br": 1,
  "gmail.ru": 1,
  "gmx.at": 1,
  "gmx.ch": 1,
  "gmx.com": 1,
  "gmx.de": 1,
  "gmx.li": 1,
  "gmx.net": 1,
  "go.com": 1,
  "go.ro": 1,
  "go.ru": 1,
  "go2net.com": 1,
  "gocollege.com": 1,
  "gocubs.com": 1,
  "goemailgo.com": 1,
  "gofree.co.uk": 1,
  "gol.com": 1,
  "goldenmail.ru": 1,
  "goldmail.ru": 1,
  "goldtoolbox.com": 1,
  "golfemail.com": 1,
  "golfilla.info": 1,
  "golfmail.be": 1,
  "gonavy.net": 1,
  "goodnewsmail.com": 1,
  "goodstick.com": 1,
  "googlegroups.com": 1,
  "googlemail.com": 1,
  "goplay.com": 1,
  "gorillaswithdirtyarmpits.com": 1,
  "gorontalo.net": 1,
  "gospelfan.com": 1,
  "gothere.uk.com": 1,
  "gotmail.com": 1,
  "gotmail.org": 1,
  "gotomy.com": 1,
  "gotti.otherinbox.com": 1,
  "gportal.hu": 1,
  "graduate.org": 1,
  "graffiti.net": 1,
  "gramszu.net": 1,
  "grandmamail.com": 1,
  "grandmasmail.com": 1,
  "graphic-designer.com": 1,
  "grapplers.com": 1,
  "gratisweb.com": 1,
  "greenmail.net": 1,
  "groupmail.com": 1,
  "grr.la": 1,
  "grungecafe.com": 1,
  "gtmc.net": 1,
  "gua.net": 1,
  "guessmail.com": 1,
  "guju.net": 1,
  "gustr.com": 1,
  "guy.com": 1,
  "guy2.com": 1,
  "guyanafriends.com": 1,
  "gyorsposta.com": 1,
  "gyorsposta.hu": 1,
  "h-mail.us": 1,
  "hab-verschlafen.de": 1,
  "habmalnefrage.de": 1,
  "hacccc.com": 1,
  "hackermail.com": 1,
  "hackermail.net": 1,
  "hailmail.net": 1,
  "hairdresser.net": 1,
  "hamptonroads.com": 1,
  "handbag.com": 1,
  "handleit.com": 1,
  "hang-ten.com": 1,
  "hanmail.net": 1,
  "happemail.com": 1,
  "happycounsel.com": 1,
  "happypuppy.com": 1,
  "harakirimail.com": 1,
  "hardcorefreak.com": 1,
  "hartbot.de": 1,
  "hawaii.rr.com": 1,
  "hawaiiantel.net": 1,
  "heartthrob.com": 1,
  "heerschap.com": 1,
  "heesun.net": 1,
  "hehe.com": 1,
  "hello.hu": 1,
  "hello.net.au": 1,
  "hello.to": 1,
  "helter-skelter.com": 1,
  "herediano.com": 1,
  "herono1.com": 1,
  "herp.in": 1,
  "herr-der-mails.de": 1,
  "hetnet.nl": 1,
  "hey.to": 1,
  "hhdevel.com": 1,
  "hidzz.com": 1,
  "highmilton.com": 1,
  "highquality.com": 1,
  "highveldmail.co.za": 1,
  "hilarious.com": 1,
  "hiphopfan.com": 1,
  "hispavista.com": 1,
  "hitmail.com": 1,
  "hitthe.net": 1,
  "hkg.net": 1,
  "hkstarphoto.com": 1,
  "hockeymail.com": 1,
  "hollywoodkids.com": 1,
  "home-email.com": 1,
  "home.de": 1,
  "home.nl": 1,
  "home.no.net": 1,
  "home.ro": 1,
  "home.se": 1,
  "homelocator.com": 1,
  "homemail.com": 1,
  "homestead.com": 1,
  "honduras.com": 1,
  "hongkong.com": 1,
  "hookup.net": 1,
  "hoopsmail.com": 1,
  "hopemail.biz": 1,
  "horrormail.com": 1,
  "hot-mail.gq": 1,
  "hot-shot.com": 1,
  "hot.ee": 1,
  "hotbot.com": 1,
  "hotbrev.com": 1,
  "hotfire.net": 1,
  "hotletter.com": 1,
  "hotmail.ca": 1,
  "hotmail.ch": 1,
  "hotmail.co": 1,
  "hotmail.co.il": 1,
  "hotmail.co.jp": 1,
  "hotmail.co.nz": 1,
  "hotmail.co.uk": 1,
  "hotmail.co.za": 1,
  "hotmail.com": 1,
  "hotmail.com.au": 1,
  "hotmail.com.br": 1,
  "hotmail.com.tr": 1,
  "hotmail.de": 1,
  "hotmail.es": 1,
  "hotmail.fi": 1,
  "hotmail.fr": 1,
  "hotmail.it": 1,
  "hotmail.kg": 1,
  "hotmail.kz": 1,
  "hotmail.nl": 1,
  "hotmail.ru": 1,
  "hotpop.com": 1,
  "hotpop3.com": 1,
  "hotvoice.com": 1,
  "housemail.com": 1,
  "hsuchi.net": 1,
  "hu2.ru": 1,
  "hughes.net": 1,
  "humanoid.net": 1,
  "humn.ws.gy": 1,
  "hunsa.com": 1,
  "hurting.com": 1,
  "hush.com": 1,
  "hushmail.com": 1,
  "hypernautica.com": 1,
  "i-connect.com": 1,
  "i-france.com": 1,
  "i-mail.com.au": 1,
  "i-p.com": 1,
  "i.am": 1,
  "i.ua": 1,
  "i12.com": 1,
  "i2pmail.org": 1,
  "iamawoman.com": 1,
  "iamwaiting.com": 1,
  "iamwasted.com": 1,
  "iamyours.com": 1,
  "icestorm.com": 1,
  "ich-bin-verrueckt-nach-dir.de": 1,
  "ich-will-net.de": 1,
  "icloud.com": 1,
  "icmsconsultants.com": 1,
  "icq.com": 1,
  "icqmail.com": 1,
  "icrazy.com": 1,
  "id-base.com": 1,
  "ididitmyway.com": 1,
  "idigjesus.com": 1,
  "idirect.com": 1,
  "ieatspam.eu": 1,
  "ieatspam.info": 1,
  "ieh-mail.de": 1,
  "iespana.es": 1,
  "ifoward.com": 1,
  "ig.com.br": 1,
  "ignazio.it": 1,
  "ignmail.com": 1,
  "ihateclowns.com": 1,
  "ihateyoualot.info": 1,
  "iheartspam.org": 1,
  "iinet.net.au": 1,
  "ijustdontcare.com": 1,
  "ikbenspamvrij.nl": 1,
  "ilkposta.com": 1,
  "ilovechocolate.com": 1,
  "ilovejesus.com": 1,
  "ilovetocollect.net": 1,
  "ilse.nl": 1,
  "imaginemail.com": 1,
  "imail.ru": 1,
  "imailbox.com": 1,
  "imap-mail.com": 1,
  "imap.cc": 1,
  "imapmail.org": 1,
  "imel.org": 1,
  "imgof.com": 1,
  "imgv.de": 1,
  "immo-gerance.info": 1,
  "imneverwrong.com": 1,
  "imposter.co.uk": 1,
  "imstations.com": 1,
  "imstressed.com": 1,
  "imtoosexy.com": 1,
  "in-box.net": 1,
  "in2jesus.com": 1,
  "iname.com": 1,
  "inbax.tk": 1,
  "inbound.plus": 1,
  "inbox.com": 1,
  "inbox.net": 1,
  "inbox.ru": 1,
  "inbox.si": 1,
  "inboxalias.com": 1,
  "incamail.com": 1,
  "incredimail.com": 1,
  "indeedemail.com": 1,
  "index.ua": 1,
  "indexa.fr": 1,
  "india.com": 1,
  "indiatimes.com": 1,
  "indo-mail.com": 1,
  "indocities.com": 1,
  "indomail.com": 1,
  "indyracers.com": 1,
  "inerted.com": 1,
  "inet.com": 1,
  "inet.net.au": 1,
  "info-media.de": 1,
  "info-radio.ml": 1,
  "info66.com": 1,
  "infohq.com": 1,
  "infomail.es": 1,
  "infomart.or.jp": 1,
  "infospacemail.com": 1,
  "infovia.com.ar": 1,
  "inicia.es": 1,
  "inmail.sk": 1,
  "inmail24.com": 1,
  "inmano.com": 1,
  "inmynetwork.tk": 1,
  "innocent.com": 1,
  "inorbit.com": 1,
  "inoutbox.com": 1,
  "insidebaltimore.net": 1,
  "insight.rr.com": 1,
  "instant-mail.de": 1,
  "instantemailaddress.com": 1,
  "instantmail.fr": 1,
  "instruction.com": 1,
  "instructor.net": 1,
  "insurer.com": 1,
  "interburp.com": 1,
  "interfree.it": 1,
  "interia.pl": 1,
  "interlap.com.ar": 1,
  "intermail.co.il": 1,
  "internet-e-mail.com": 1,
  "internet-mail.org": 1,
  "internet-police.com": 1,
  "internetbiz.com": 1,
  "internetdrive.com": 1,
  "internetegypt.com": 1,
  "internetemails.net": 1,
  "internetmailing.net": 1,
  "internode.on.net": 1,
  "invalid.com": 1,
  "inwind.it": 1,
  "iobox.com": 1,
  "iobox.fi": 1,
  "iol.it": 1,
  "iol.pt": 1,
  "iowaemail.com": 1,
  "ip3.com": 1,
  "ip4.pp.ua": 1,
  "ip6.pp.ua": 1,
  "ipoo.org": 1,
  "iprimus.com.au": 1,
  "iqemail.com": 1,
  "irangate.net": 1,
  "iraqmail.com": 1,
  "ireland.com": 1,
  "irelandmail.com": 1,
  "iremail.de": 1,
  "irj.hu": 1,
  "iroid.com": 1,
  "isellcars.com": 1,
  "iservejesus.com": 1,
  "islamonline.net": 1,
  "isleuthmail.com": 1,
  "ismart.net": 1,
  "isonfire.com": 1,
  "isp9.net": 1,
  "israelmail.com": 1,
  "ist-allein.info": 1,
  "ist-einmalig.de": 1,
  "ist-ganz-allein.de": 1,
  "ist-willig.de": 1,
  "italymail.com": 1,
  "itloox.com": 1,
  "itmom.com": 1,
  "ivebeenframed.com": 1,
  "ivillage.com": 1,
  "iwan-fals.com": 1,
  "iwmail.com": 1,
  "iwon.com": 1,
  "izadpanah.com": 1,
  "jahoopa.com": 1,
  "jakuza.hu": 1,
  "japan.com": 1,
  "jaydemail.com": 1,
  "jazzandjava.com": 1,
  "jazzfan.com": 1,
  "jazzgame.com": 1,
  "je-recycle.info": 1,
  "jerusalemmail.com": 1,
  "jet-renovation.fr": 1,
  "jetable.de": 1,
  "jetable.pp.ua": 1,
  "jetemail.net": 1,
  "jippii.fi": 1,
  "jmail.co.za": 1,
  "job4u.com": 1,
  "jobbikszimpatizans.hu": 1,
  "joelonsoftware.com": 1,
  "joinme.com": 1,
  "jokes.com": 1,
  "jordanmail.com": 1,
  "journalist.com": 1,
  "jourrapide.com": 1,
  "jovem.te.pt": 1,
  "joymail.com": 1,
  "jpopmail.com": 1,
  "jsrsolutions.com": 1,
  "jubiimail.dk": 1,
  "jump.com": 1,
  "jumpy.it": 1,
  "juniormail.com": 1,
  "junk1e.com": 1,
  "junkmail.com": 1,
  "junkmail.gq": 1,
  "juno.com": 1,
  "justemail.net": 1,
  "justicemail.com": 1,
  "kaazoo.com": 1,
  "kaffeeschluerfer.com": 1,
  "kaffeeschluerfer.de": 1,
  "kaixo.com": 1,
  "kalpoint.com": 1,
  "kansascity.com": 1,
  "kapoorweb.com": 1,
  "karachian.com": 1,
  "karachioye.com": 1,
  "karbasi.com": 1,
  "katamail.com": 1,
  "kayafmmail.co.za": 1,
  "kbjrmail.com": 1,
  "kcks.com": 1,
  "keg-party.com": 1,
  "keinpardon.de": 1,
  "keko.com.ar": 1,
  "kellychen.com": 1,
  "keromail.com": 1,
  "keyemail.com": 1,
  "kgb.hu": 1,
  "khosropour.com": 1,
  "kickassmail.com": 1,
  "killermail.com": 1,
  "kimo.com": 1,
  "kimsdisk.com": 1,
  "kinglibrary.net": 1,
  "kinki-kids.com": 1,
  "kissfans.com": 1,
  "kittymail.com": 1,
  "kitznet.at": 1,
  "kiwibox.com": 1,
  "kiwitown.com": 1,
  "klassmaster.net": 1,
  "km.ru": 1,
  "knol-power.nl": 1,
  "kolumbus.fi": 1,
  "kommespaeter.de": 1,
  "konx.com": 1,
  "korea.com": 1,
  "koreamail.com": 1,
  "kpnmail.nl": 1,
  "krim.ws": 1,
  "krongthip.com": 1,
  "krunis.com": 1,
  "ksanmail.com": 1,
  "ksee24mail.com": 1,
  "kube93mail.com": 1,
  "kukamail.com": 1,
  "kulturbetrieb.info": 1,
  "kumarweb.com": 1,
  "kuwait-mail.com": 1,
  "l33r.eu": 1,
  "la.com": 1,
  "labetteraverouge.at": 1,
  "ladymail.cz": 1,
  "lagerlouts.com": 1,
  "lags.us": 1,
  "lahoreoye.com": 1,
  "lakmail.com": 1,
  "lamer.hu": 1,
  "land.ru": 1,
  "lankamail.com": 1,
  "laoeq.com": 1,
  "laposte.net": 1,
  "lass-es-geschehen.de": 1,
  "last-chance.pro": 1,
  "lastmail.co": 1,
  "latemodels.com": 1,
  "latinmail.com": 1,
  "lavache.com": 1,
  "law.com": 1,
  "lawyer.com": 1,
  "lazyinbox.com": 1,
  "leehom.net": 1,
  "legalactions.com": 1,
  "legalrc.loan": 1,
  "legislator.com": 1,
  "lenta.ru": 1,
  "leonlai.net": 1,
  "letsgomets.net": 1,
  "letterboxes.org": 1,
  "letthemeatspam.com": 1,
  "levele.com": 1,
  "levele.hu": 1,
  "lex.bg": 1,
  "lexis-nexis-mail.com": 1,
  "libero.it": 1,
  "liberomail.com": 1,
  "lick101.com": 1,
  "liebt-dich.info": 1,
  "linkmaster.com": 1,
  "linktrader.com": 1,
  "linuxfreemail.com": 1,
  "linuxmail.org": 1,
  "lionsfan.com.au": 1,
  "liontrucks.com": 1,
  "liquidinformation.net": 1,
  "list.ru": 1,
  "listomail.com": 1,
  "littleapple.com": 1,
  "littleblueroom.com": 1,
  "live.at": 1,
  "live.be": 1,
  "live.ca": 1,
  "live.cl": 1,
  "live.cn": 1,
  "live.co.uk": 1,
  "live.co.za": 1,
  "live.com": 1,
  "live.com.ar": 1,
  "live.com.au": 1,
  "live.com.mx": 1,
  "live.com.pt": 1,
  "live.com.sg": 1,
  "live.de": 1,
  "live.dk": 1,
  "live.fr": 1,
  "live.ie": 1,
  "live.in": 1,
  "live.it": 1,
  "live.jp": 1,
  "live.nl": 1,
  "live.no": 1,
  "live.ru": 1,
  "live.se": 1,
  "liveradio.tk": 1,
  "liverpoolfans.com": 1,
  "llandudno.com": 1,
  "llangollen.com": 1,
  "lmxmail.sk": 1,
  "lobbyist.com": 1,
  "localbar.com": 1,
  "locos.com": 1,
  "login-email.ga": 1,
  "loh.pp.ua": 1,
  "lolfreak.net": 1,
  "lolito.tk": 1,
  "london.com": 1,
  "looksmart.co.uk": 1,
  "looksmart.com": 1,
  "looksmart.com.au": 1,
  "lopezclub.com": 1,
  "louiskoo.com": 1,
  "love.cz": 1,
  "loveable.com": 1,
  "lovecat.com": 1,
  "lovefall.ml": 1,
  "lovefootball.com": 1,
  "lovelygirl.net": 1,
  "lovemail.com": 1,
  "lover-boy.com": 1,
  "lovergirl.com": 1,
  "lovesea.gq": 1,
  "lovethebroncos.com": 1,
  "lovethecowboys.com": 1,
  "loveyouforever.de": 1,
  "lovingjesus.com": 1,
  "lowandslow.com": 1,
  "lr7.us": 1,
  "lroid.com": 1,
  "luso.pt": 1,
  "luukku.com": 1,
  "luv2.us": 1,
  "lvie.com.sg": 1,
  "lycos.co.uk": 1,
  "lycos.com": 1,
  "lycos.es": 1,
  "lycos.it": 1,
  "lycos.ne.jp": 1,
  "lycosmail.com": 1,
  "m-a-i-l.com": 1,
  "m-hmail.com": 1,
  "m4.org": 1,
  "m4ilweb.info": 1,
  "mac.com": 1,
  "macbox.com": 1,
  "macfreak.com": 1,
  "machinecandy.com": 1,
  "macmail.com": 1,
  "madcreations.com": 1,
  "madonnafan.com": 1,
  "madrid.com": 1,
  "maennerversteherin.com": 1,
  "maennerversteherin.de": 1,
  "maffia.hu": 1,
  "magicmail.co.za": 1,
  "magspam.net": 1,
  "mahmoodweb.com": 1,
  "mail.bg": 1,
  "mail-awu.de": 1,
  "mail-box.cz": 1,
  "mail-center.com": 1,
  "mail-central.com": 1,
  "mail-easy.fr": 1,
  "mail-filter.com": 1,
  "mail-me.com": 1,
  "mail-page.com": 1,
  "mail-tester.com": 1,
  "mail.austria.com": 1,
  "mail.az": 1,
  "mail.be": 1,
  "mail.bulgaria.com": 1,
  "mail.by": 1,
  "mail.co.za": 1,
  "mail.com": 1,
  "mail.com.tr": 1,
  "mail.de": 1,
  "mail.ee": 1,
  "mail.entrepeneurmag.com": 1,
  "mail.freetown.com": 1,
  "mail.gr": 1,
  "mail.hitthebeach.com": 1,
  "mail.htl22.at": 1,
  "mail.md": 1,
  "mail.misterpinball.de": 1,
  "mail.nu": 1,
  "mail.org.uk": 1,
  "mail.pf": 1,
  "mail.pt": 1,
  "mail.r-o-o-t.com": 1,
  "mail.ru": 1,
  "mail.sisna.com": 1,
  "mail.svenz.eu": 1,
  "mail.usa.com": 1,
  "mail.vasarhely.hu": 1,
  "mail.wtf": 1,
  "mail114.net": 1,
  "mail15.com": 1,
  "mail2007.com": 1,
  "mail2aaron.com": 1,
  "mail2abby.com": 1,
  "mail2abc.com": 1,
  "mail2actor.com": 1,
  "mail2admiral.com": 1,
  "mail2adorable.com": 1,
  "mail2adoration.com": 1,
  "mail2adore.com": 1,
  "mail2adventure.com": 1,
  "mail2aeolus.com": 1,
  "mail2aether.com": 1,
  "mail2affection.com": 1,
  "mail2afghanistan.com": 1,
  "mail2africa.com": 1,
  "mail2agent.com": 1,
  "mail2aha.com": 1,
  "mail2ahoy.com": 1,
  "mail2aim.com": 1,
  "mail2air.com": 1,
  "mail2airbag.com": 1,
  "mail2airforce.com": 1,
  "mail2airport.com": 1,
  "mail2alabama.com": 1,
  "mail2alan.com": 1,
  "mail2alaska.com": 1,
  "mail2albania.com": 1,
  "mail2alcoholic.com": 1,
  "mail2alec.com": 1,
  "mail2alexa.com": 1,
  "mail2algeria.com": 1,
  "mail2alicia.com": 1,
  "mail2alien.com": 1,
  "mail2allan.com": 1,
  "mail2allen.com": 1,
  "mail2allison.com": 1,
  "mail2alpha.com": 1,
  "mail2alyssa.com": 1,
  "mail2amanda.com": 1,
  "mail2amazing.com": 1,
  "mail2amber.com": 1,
  "mail2america.com": 1,
  "mail2american.com": 1,
  "mail2andorra.com": 1,
  "mail2andrea.com": 1,
  "mail2andy.com": 1,
  "mail2anesthesiologist.com": 1,
  "mail2angela.com": 1,
  "mail2angola.com": 1,
  "mail2ann.com": 1,
  "mail2anna.com": 1,
  "mail2anne.com": 1,
  "mail2anthony.com": 1,
  "mail2anything.com": 1,
  "mail2aphrodite.com": 1,
  "mail2apollo.com": 1,
  "mail2april.com": 1,
  "mail2aquarius.com": 1,
  "mail2arabia.com": 1,
  "mail2arabic.com": 1,
  "mail2architect.com": 1,
  "mail2ares.com": 1,
  "mail2argentina.com": 1,
  "mail2aries.com": 1,
  "mail2arizona.com": 1,
  "mail2arkansas.com": 1,
  "mail2armenia.com": 1,
  "mail2army.com": 1,
  "mail2arnold.com": 1,
  "mail2art.com": 1,
  "mail2artemus.com": 1,
  "mail2arthur.com": 1,
  "mail2artist.com": 1,
  "mail2ashley.com": 1,
  "mail2ask.com": 1,
  "mail2astronomer.com": 1,
  "mail2athena.com": 1,
  "mail2athlete.com": 1,
  "mail2atlas.com": 1,
  "mail2atom.com": 1,
  "mail2attitude.com": 1,
  "mail2auction.com": 1,
  "mail2aunt.com": 1,
  "mail2australia.com": 1,
  "mail2austria.com": 1,
  "mail2azerbaijan.com": 1,
  "mail2baby.com": 1,
  "mail2bahamas.com": 1,
  "mail2bahrain.com": 1,
  "mail2ballerina.com": 1,
  "mail2ballplayer.com": 1,
  "mail2band.com": 1,
  "mail2bangladesh.com": 1,
  "mail2bank.com": 1,
  "mail2banker.com": 1,
  "mail2bankrupt.com": 1,
  "mail2baptist.com": 1,
  "mail2bar.com": 1,
  "mail2barbados.com": 1,
  "mail2barbara.com": 1,
  "mail2barter.com": 1,
  "mail2basketball.com": 1,
  "mail2batter.com": 1,
  "mail2beach.com": 1,
  "mail2beast.com": 1,
  "mail2beatles.com": 1,
  "mail2beauty.com": 1,
  "mail2becky.com": 1,
  "mail2beijing.com": 1,
  "mail2belgium.com": 1,
  "mail2belize.com": 1,
  "mail2ben.com": 1,
  "mail2bernard.com": 1,
  "mail2beth.com": 1,
  "mail2betty.com": 1,
  "mail2beverly.com": 1,
  "mail2beyond.com": 1,
  "mail2biker.com": 1,
  "mail2bill.com": 1,
  "mail2billionaire.com": 1,
  "mail2billy.com": 1,
  "mail2bio.com": 1,
  "mail2biologist.com": 1,
  "mail2black.com": 1,
  "mail2blackbelt.com": 1,
  "mail2blake.com": 1,
  "mail2blind.com": 1,
  "mail2blonde.com": 1,
  "mail2blues.com": 1,
  "mail2bob.com": 1,
  "mail2bobby.com": 1,
  "mail2bolivia.com": 1,
  "mail2bombay.com": 1,
  "mail2bonn.com": 1,
  "mail2bookmark.com": 1,
  "mail2boreas.com": 1,
  "mail2bosnia.com": 1,
  "mail2boston.com": 1,
  "mail2botswana.com": 1,
  "mail2bradley.com": 1,
  "mail2brazil.com": 1,
  "mail2breakfast.com": 1,
  "mail2brian.com": 1,
  "mail2bride.com": 1,
  "mail2brittany.com": 1,
  "mail2broker.com": 1,
  "mail2brook.com": 1,
  "mail2bruce.com": 1,
  "mail2brunei.com": 1,
  "mail2brunette.com": 1,
  "mail2brussels.com": 1,
  "mail2bryan.com": 1,
  "mail2bug.com": 1,
  "mail2bulgaria.com": 1,
  "mail2business.com": 1,
  "mail2buy.com": 1,
  "mail2ca.com": 1,
  "mail2california.com": 1,
  "mail2calvin.com": 1,
  "mail2cambodia.com": 1,
  "mail2cameroon.com": 1,
  "mail2canada.com": 1,
  "mail2cancer.com": 1,
  "mail2capeverde.com": 1,
  "mail2capricorn.com": 1,
  "mail2cardinal.com": 1,
  "mail2cardiologist.com": 1,
  "mail2care.com": 1,
  "mail2caroline.com": 1,
  "mail2carolyn.com": 1,
  "mail2casey.com": 1,
  "mail2cat.com": 1,
  "mail2caterer.com": 1,
  "mail2cathy.com": 1,
  "mail2catlover.com": 1,
  "mail2catwalk.com": 1,
  "mail2cell.com": 1,
  "mail2chad.com": 1,
  "mail2champaign.com": 1,
  "mail2charles.com": 1,
  "mail2chef.com": 1,
  "mail2chemist.com": 1,
  "mail2cherry.com": 1,
  "mail2chicago.com": 1,
  "mail2chile.com": 1,
  "mail2china.com": 1,
  "mail2chinese.com": 1,
  "mail2chocolate.com": 1,
  "mail2christian.com": 1,
  "mail2christie.com": 1,
  "mail2christmas.com": 1,
  "mail2christy.com": 1,
  "mail2chuck.com": 1,
  "mail2cindy.com": 1,
  "mail2clark.com": 1,
  "mail2classifieds.com": 1,
  "mail2claude.com": 1,
  "mail2cliff.com": 1,
  "mail2clinic.com": 1,
  "mail2clint.com": 1,
  "mail2close.com": 1,
  "mail2club.com": 1,
  "mail2coach.com": 1,
  "mail2coastguard.com": 1,
  "mail2colin.com": 1,
  "mail2college.com": 1,
  "mail2colombia.com": 1,
  "mail2color.com": 1,
  "mail2colorado.com": 1,
  "mail2columbia.com": 1,
  "mail2comedian.com": 1,
  "mail2composer.com": 1,
  "mail2computer.com": 1,
  "mail2computers.com": 1,
  "mail2concert.com": 1,
  "mail2congo.com": 1,
  "mail2connect.com": 1,
  "mail2connecticut.com": 1,
  "mail2consultant.com": 1,
  "mail2convict.com": 1,
  "mail2cook.com": 1,
  "mail2cool.com": 1,
  "mail2cory.com": 1,
  "mail2costarica.com": 1,
  "mail2country.com": 1,
  "mail2courtney.com": 1,
  "mail2cowboy.com": 1,
  "mail2cowgirl.com": 1,
  "mail2craig.com": 1,
  "mail2crave.com": 1,
  "mail2crazy.com": 1,
  "mail2create.com": 1,
  "mail2croatia.com": 1,
  "mail2cry.com": 1,
  "mail2crystal.com": 1,
  "mail2cuba.com": 1,
  "mail2culture.com": 1,
  "mail2curt.com": 1,
  "mail2customs.com": 1,
  "mail2cute.com": 1,
  "mail2cutey.com": 1,
  "mail2cynthia.com": 1,
  "mail2cyprus.com": 1,
  "mail2czechrepublic.com": 1,
  "mail2dad.com": 1,
  "mail2dale.com": 1,
  "mail2dallas.com": 1,
  "mail2dan.com": 1,
  "mail2dana.com": 1,
  "mail2dance.com": 1,
  "mail2dancer.com": 1,
  "mail2danielle.com": 1,
  "mail2danny.com": 1,
  "mail2darlene.com": 1,
  "mail2darling.com": 1,
  "mail2darren.com": 1,
  "mail2daughter.com": 1,
  "mail2dave.com": 1,
  "mail2dawn.com": 1,
  "mail2dc.com": 1,
  "mail2dealer.com": 1,
  "mail2deanna.com": 1,
  "mail2dearest.com": 1,
  "mail2debbie.com": 1,
  "mail2debby.com": 1,
  "mail2deer.com": 1,
  "mail2delaware.com": 1,
  "mail2delicious.com": 1,
  "mail2demeter.com": 1,
  "mail2democrat.com": 1,
  "mail2denise.com": 1,
  "mail2denmark.com": 1,
  "mail2dennis.com": 1,
  "mail2dentist.com": 1,
  "mail2derek.com": 1,
  "mail2desert.com": 1,
  "mail2devoted.com": 1,
  "mail2devotion.com": 1,
  "mail2diamond.com": 1,
  "mail2diana.com": 1,
  "mail2diane.com": 1,
  "mail2diehard.com": 1,
  "mail2dilemma.com": 1,
  "mail2dillon.com": 1,
  "mail2dinner.com": 1,
  "mail2dinosaur.com": 1,
  "mail2dionysos.com": 1,
  "mail2diplomat.com": 1,
  "mail2director.com": 1,
  "mail2dirk.com": 1,
  "mail2disco.com": 1,
  "mail2dive.com": 1,
  "mail2diver.com": 1,
  "mail2divorced.com": 1,
  "mail2djibouti.com": 1,
  "mail2doctor.com": 1,
  "mail2doglover.com": 1,
  "mail2dominic.com": 1,
  "mail2dominica.com": 1,
  "mail2dominicanrepublic.com": 1,
  "mail2don.com": 1,
  "mail2donald.com": 1,
  "mail2donna.com": 1,
  "mail2doris.com": 1,
  "mail2dorothy.com": 1,
  "mail2doug.com": 1,
  "mail2dough.com": 1,
  "mail2douglas.com": 1,
  "mail2dow.com": 1,
  "mail2downtown.com": 1,
  "mail2dream.com": 1,
  "mail2dreamer.com": 1,
  "mail2dude.com": 1,
  "mail2dustin.com": 1,
  "mail2dyke.com": 1,
  "mail2dylan.com": 1,
  "mail2earl.com": 1,
  "mail2earth.com": 1,
  "mail2eastend.com": 1,
  "mail2eat.com": 1,
  "mail2economist.com": 1,
  "mail2ecuador.com": 1,
  "mail2eddie.com": 1,
  "mail2edgar.com": 1,
  "mail2edwin.com": 1,
  "mail2egypt.com": 1,
  "mail2electron.com": 1,
  "mail2eli.com": 1,
  "mail2elizabeth.com": 1,
  "mail2ellen.com": 1,
  "mail2elliot.com": 1,
  "mail2elsalvador.com": 1,
  "mail2elvis.com": 1,
  "mail2emergency.com": 1,
  "mail2emily.com": 1,
  "mail2engineer.com": 1,
  "mail2english.com": 1,
  "mail2environmentalist.com": 1,
  "mail2eos.com": 1,
  "mail2eric.com": 1,
  "mail2erica.com": 1,
  "mail2erin.com": 1,
  "mail2erinyes.com": 1,
  "mail2eris.com": 1,
  "mail2eritrea.com": 1,
  "mail2ernie.com": 1,
  "mail2eros.com": 1,
  "mail2estonia.com": 1,
  "mail2ethan.com": 1,
  "mail2ethiopia.com": 1,
  "mail2eu.com": 1,
  "mail2europe.com": 1,
  "mail2eurus.com": 1,
  "mail2eva.com": 1,
  "mail2evan.com": 1,
  "mail2evelyn.com": 1,
  "mail2everything.com": 1,
  "mail2exciting.com": 1,
  "mail2expert.com": 1,
  "mail2fairy.com": 1,
  "mail2faith.com": 1,
  "mail2fanatic.com": 1,
  "mail2fancy.com": 1,
  "mail2fantasy.com": 1,
  "mail2farm.com": 1,
  "mail2farmer.com": 1,
  "mail2fashion.com": 1,
  "mail2fat.com": 1,
  "mail2feeling.com": 1,
  "mail2female.com": 1,
  "mail2fever.com": 1,
  "mail2fighter.com": 1,
  "mail2fiji.com": 1,
  "mail2filmfestival.com": 1,
  "mail2films.com": 1,
  "mail2finance.com": 1,
  "mail2finland.com": 1,
  "mail2fireman.com": 1,
  "mail2firm.com": 1,
  "mail2fisherman.com": 1,
  "mail2flexible.com": 1,
  "mail2florence.com": 1,
  "mail2florida.com": 1,
  "mail2floyd.com": 1,
  "mail2fly.com": 1,
  "mail2fond.com": 1,
  "mail2fondness.com": 1,
  "mail2football.com": 1,
  "mail2footballfan.com": 1,
  "mail2found.com": 1,
  "mail2france.com": 1,
  "mail2frank.com": 1,
  "mail2frankfurt.com": 1,
  "mail2franklin.com": 1,
  "mail2fred.com": 1,
  "mail2freddie.com": 1,
  "mail2free.com": 1,
  "mail2freedom.com": 1,
  "mail2french.com": 1,
  "mail2freudian.com": 1,
  "mail2friendship.com": 1,
  "mail2from.com": 1,
  "mail2fun.com": 1,
  "mail2gabon.com": 1,
  "mail2gabriel.com": 1,
  "mail2gail.com": 1,
  "mail2galaxy.com": 1,
  "mail2gambia.com": 1,
  "mail2games.com": 1,
  "mail2gary.com": 1,
  "mail2gavin.com": 1,
  "mail2gemini.com": 1,
  "mail2gene.com": 1,
  "mail2genes.com": 1,
  "mail2geneva.com": 1,
  "mail2george.com": 1,
  "mail2georgia.com": 1,
  "mail2gerald.com": 1,
  "mail2german.com": 1,
  "mail2germany.com": 1,
  "mail2ghana.com": 1,
  "mail2gilbert.com": 1,
  "mail2gina.com": 1,
  "mail2girl.com": 1,
  "mail2glen.com": 1,
  "mail2gloria.com": 1,
  "mail2goddess.com": 1,
  "mail2gold.com": 1,
  "mail2golfclub.com": 1,
  "mail2golfer.com": 1,
  "mail2gordon.com": 1,
  "mail2government.com": 1,
  "mail2grab.com": 1,
  "mail2grace.com": 1,
  "mail2graham.com": 1,
  "mail2grandma.com": 1,
  "mail2grandpa.com": 1,
  "mail2grant.com": 1,
  "mail2greece.com": 1,
  "mail2green.com": 1,
  "mail2greg.com": 1,
  "mail2grenada.com": 1,
  "mail2gsm.com": 1,
  "mail2guard.com": 1,
  "mail2guatemala.com": 1,
  "mail2guy.com": 1,
  "mail2hades.com": 1,
  "mail2haiti.com": 1,
  "mail2hal.com": 1,
  "mail2handhelds.com": 1,
  "mail2hank.com": 1,
  "mail2hannah.com": 1,
  "mail2harold.com": 1,
  "mail2harry.com": 1,
  "mail2hawaii.com": 1,
  "mail2headhunter.com": 1,
  "mail2heal.com": 1,
  "mail2heather.com": 1,
  "mail2heaven.com": 1,
  "mail2hebe.com": 1,
  "mail2hecate.com": 1,
  "mail2heidi.com": 1,
  "mail2helen.com": 1,
  "mail2hell.com": 1,
  "mail2help.com": 1,
  "mail2helpdesk.com": 1,
  "mail2henry.com": 1,
  "mail2hephaestus.com": 1,
  "mail2hera.com": 1,
  "mail2hercules.com": 1,
  "mail2herman.com": 1,
  "mail2hermes.com": 1,
  "mail2hespera.com": 1,
  "mail2hestia.com": 1,
  "mail2highschool.com": 1,
  "mail2hindu.com": 1,
  "mail2hip.com": 1,
  "mail2hiphop.com": 1,
  "mail2holland.com": 1,
  "mail2holly.com": 1,
  "mail2hollywood.com": 1,
  "mail2homer.com": 1,
  "mail2honduras.com": 1,
  "mail2honey.com": 1,
  "mail2hongkong.com": 1,
  "mail2hope.com": 1,
  "mail2horse.com": 1,
  "mail2hot.com": 1,
  "mail2hotel.com": 1,
  "mail2houston.com": 1,
  "mail2howard.com": 1,
  "mail2hugh.com": 1,
  "mail2human.com": 1,
  "mail2hungary.com": 1,
  "mail2hungry.com": 1,
  "mail2hygeia.com": 1,
  "mail2hyperspace.com": 1,
  "mail2hypnos.com": 1,
  "mail2ian.com": 1,
  "mail2ice-cream.com": 1,
  "mail2iceland.com": 1,
  "mail2idaho.com": 1,
  "mail2idontknow.com": 1,
  "mail2illinois.com": 1,
  "mail2imam.com": 1,
  "mail2in.com": 1,
  "mail2india.com": 1,
  "mail2indian.com": 1,
  "mail2indiana.com": 1,
  "mail2indonesia.com": 1,
  "mail2infinity.com": 1,
  "mail2intense.com": 1,
  "mail2iowa.com": 1,
  "mail2iran.com": 1,
  "mail2iraq.com": 1,
  "mail2ireland.com": 1,
  "mail2irene.com": 1,
  "mail2iris.com": 1,
  "mail2irresistible.com": 1,
  "mail2irving.com": 1,
  "mail2irwin.com": 1,
  "mail2isaac.com": 1,
  "mail2israel.com": 1,
  "mail2italian.com": 1,
  "mail2italy.com": 1,
  "mail2jackie.com": 1,
  "mail2jacob.com": 1,
  "mail2jail.com": 1,
  "mail2jaime.com": 1,
  "mail2jake.com": 1,
  "mail2jamaica.com": 1,
  "mail2james.com": 1,
  "mail2jamie.com": 1,
  "mail2jan.com": 1,
  "mail2jane.com": 1,
  "mail2janet.com": 1,
  "mail2janice.com": 1,
  "mail2japan.com": 1,
  "mail2japanese.com": 1,
  "mail2jasmine.com": 1,
  "mail2jason.com": 1,
  "mail2java.com": 1,
  "mail2jay.com": 1,
  "mail2jazz.com": 1,
  "mail2jed.com": 1,
  "mail2jeffrey.com": 1,
  "mail2jennifer.com": 1,
  "mail2jenny.com": 1,
  "mail2jeremy.com": 1,
  "mail2jerry.com": 1,
  "mail2jessica.com": 1,
  "mail2jessie.com": 1,
  "mail2jesus.com": 1,
  "mail2jew.com": 1,
  "mail2jeweler.com": 1,
  "mail2jim.com": 1,
  "mail2jimmy.com": 1,
  "mail2joan.com": 1,
  "mail2joann.com": 1,
  "mail2joanna.com": 1,
  "mail2jody.com": 1,
  "mail2joe.com": 1,
  "mail2joel.com": 1,
  "mail2joey.com": 1,
  "mail2john.com": 1,
  "mail2join.com": 1,
  "mail2jon.com": 1,
  "mail2jonathan.com": 1,
  "mail2jones.com": 1,
  "mail2jordan.com": 1,
  "mail2joseph.com": 1,
  "mail2josh.com": 1,
  "mail2joy.com": 1,
  "mail2juan.com": 1,
  "mail2judge.com": 1,
  "mail2judy.com": 1,
  "mail2juggler.com": 1,
  "mail2julian.com": 1,
  "mail2julie.com": 1,
  "mail2jumbo.com": 1,
  "mail2junk.com": 1,
  "mail2justin.com": 1,
  "mail2justme.com": 1,
  "mail2k.ru": 1,
  "mail2kansas.com": 1,
  "mail2karate.com": 1,
  "mail2karen.com": 1,
  "mail2karl.com": 1,
  "mail2karma.com": 1,
  "mail2kathleen.com": 1,
  "mail2kathy.com": 1,
  "mail2katie.com": 1,
  "mail2kay.com": 1,
  "mail2kazakhstan.com": 1,
  "mail2keen.com": 1,
  "mail2keith.com": 1,
  "mail2kelly.com": 1,
  "mail2kelsey.com": 1,
  "mail2ken.com": 1,
  "mail2kendall.com": 1,
  "mail2kennedy.com": 1,
  "mail2kenneth.com": 1,
  "mail2kenny.com": 1,
  "mail2kentucky.com": 1,
  "mail2kenya.com": 1,
  "mail2kerry.com": 1,
  "mail2kevin.com": 1,
  "mail2kim.com": 1,
  "mail2kimberly.com": 1,
  "mail2king.com": 1,
  "mail2kirk.com": 1,
  "mail2kiss.com": 1,
  "mail2kosher.com": 1,
  "mail2kristin.com": 1,
  "mail2kurt.com": 1,
  "mail2kuwait.com": 1,
  "mail2kyle.com": 1,
  "mail2kyrgyzstan.com": 1,
  "mail2la.com": 1,
  "mail2lacrosse.com": 1,
  "mail2lance.com": 1,
  "mail2lao.com": 1,
  "mail2larry.com": 1,
  "mail2latvia.com": 1,
  "mail2laugh.com": 1,
  "mail2laura.com": 1,
  "mail2lauren.com": 1,
  "mail2laurie.com": 1,
  "mail2lawrence.com": 1,
  "mail2lawyer.com": 1,
  "mail2lebanon.com": 1,
  "mail2lee.com": 1,
  "mail2leo.com": 1,
  "mail2leon.com": 1,
  "mail2leonard.com": 1,
  "mail2leone.com": 1,
  "mail2leslie.com": 1,
  "mail2letter.com": 1,
  "mail2liberia.com": 1,
  "mail2libertarian.com": 1,
  "mail2libra.com": 1,
  "mail2libya.com": 1,
  "mail2liechtenstein.com": 1,
  "mail2life.com": 1,
  "mail2linda.com": 1,
  "mail2linux.com": 1,
  "mail2lionel.com": 1,
  "mail2lipstick.com": 1,
  "mail2liquid.com": 1,
  "mail2lisa.com": 1,
  "mail2lithuania.com": 1,
  "mail2litigator.com": 1,
  "mail2liz.com": 1,
  "mail2lloyd.com": 1,
  "mail2lois.com": 1,
  "mail2lola.com": 1,
  "mail2london.com": 1,
  "mail2looking.com": 1,
  "mail2lori.com": 1,
  "mail2lost.com": 1,
  "mail2lou.com": 1,
  "mail2louis.com": 1,
  "mail2louisiana.com": 1,
  "mail2lovable.com": 1,
  "mail2love.com": 1,
  "mail2lucky.com": 1,
  "mail2lucy.com": 1,
  "mail2lunch.com": 1,
  "mail2lust.com": 1,
  "mail2luxembourg.com": 1,
  "mail2luxury.com": 1,
  "mail2lyle.com": 1,
  "mail2lynn.com": 1,
  "mail2madagascar.com": 1,
  "mail2madison.com": 1,
  "mail2madrid.com": 1,
  "mail2maggie.com": 1,
  "mail2mail4.com": 1,
  "mail2maine.com": 1,
  "mail2malawi.com": 1,
  "mail2malaysia.com": 1,
  "mail2maldives.com": 1,
  "mail2mali.com": 1,
  "mail2malta.com": 1,
  "mail2mambo.com": 1,
  "mail2man.com": 1,
  "mail2mandy.com": 1,
  "mail2manhunter.com": 1,
  "mail2mankind.com": 1,
  "mail2many.com": 1,
  "mail2marc.com": 1,
  "mail2marcia.com": 1,
  "mail2margaret.com": 1,
  "mail2margie.com": 1,
  "mail2marhaba.com": 1,
  "mail2maria.com": 1,
  "mail2marilyn.com": 1,
  "mail2marines.com": 1,
  "mail2mark.com": 1,
  "mail2marriage.com": 1,
  "mail2married.com": 1,
  "mail2marries.com": 1,
  "mail2mars.com": 1,
  "mail2marsha.com": 1,
  "mail2marshallislands.com": 1,
  "mail2martha.com": 1,
  "mail2martin.com": 1,
  "mail2marty.com": 1,
  "mail2marvin.com": 1,
  "mail2mary.com": 1,
  "mail2maryland.com": 1,
  "mail2mason.com": 1,
  "mail2massachusetts.com": 1,
  "mail2matt.com": 1,
  "mail2matthew.com": 1,
  "mail2maurice.com": 1,
  "mail2mauritania.com": 1,
  "mail2mauritius.com": 1,
  "mail2max.com": 1,
  "mail2maxwell.com": 1,
  "mail2maybe.com": 1,
  "mail2mba.com": 1,
  "mail2me4u.com": 1,
  "mail2mechanic.com": 1,
  "mail2medieval.com": 1,
  "mail2megan.com": 1,
  "mail2mel.com": 1,
  "mail2melanie.com": 1,
  "mail2melissa.com": 1,
  "mail2melody.com": 1,
  "mail2member.com": 1,
  "mail2memphis.com": 1,
  "mail2methodist.com": 1,
  "mail2mexican.com": 1,
  "mail2mexico.com": 1,
  "mail2mgz.com": 1,
  "mail2miami.com": 1,
  "mail2michael.com": 1,
  "mail2michelle.com": 1,
  "mail2michigan.com": 1,
  "mail2mike.com": 1,
  "mail2milan.com": 1,
  "mail2milano.com": 1,
  "mail2mildred.com": 1,
  "mail2milkyway.com": 1,
  "mail2millennium.com": 1,
  "mail2millionaire.com": 1,
  "mail2milton.com": 1,
  "mail2mime.com": 1,
  "mail2mindreader.com": 1,
  "mail2mini.com": 1,
  "mail2minister.com": 1,
  "mail2minneapolis.com": 1,
  "mail2minnesota.com": 1,
  "mail2miracle.com": 1,
  "mail2missionary.com": 1,
  "mail2mississippi.com": 1,
  "mail2missouri.com": 1,
  "mail2mitch.com": 1,
  "mail2model.com": 1,
  "mail2moldova.commail2molly.com": 1,
  "mail2mom.com": 1,
  "mail2monaco.com": 1,
  "mail2money.com": 1,
  "mail2mongolia.com": 1,
  "mail2monica.com": 1,
  "mail2montana.com": 1,
  "mail2monty.com": 1,
  "mail2moon.com": 1,
  "mail2morocco.com": 1,
  "mail2morpheus.com": 1,
  "mail2mors.com": 1,
  "mail2moscow.com": 1,
  "mail2moslem.com": 1,
  "mail2mouseketeer.com": 1,
  "mail2movies.com": 1,
  "mail2mozambique.com": 1,
  "mail2mp3.com": 1,
  "mail2mrright.com": 1,
  "mail2msright.com": 1,
  "mail2museum.com": 1,
  "mail2music.com": 1,
  "mail2musician.com": 1,
  "mail2muslim.com": 1,
  "mail2my.com": 1,
  "mail2myboat.com": 1,
  "mail2mycar.com": 1,
  "mail2mycell.com": 1,
  "mail2mygsm.com": 1,
  "mail2mylaptop.com": 1,
  "mail2mymac.com": 1,
  "mail2mypager.com": 1,
  "mail2mypalm.com": 1,
  "mail2mypc.com": 1,
  "mail2myphone.com": 1,
  "mail2myplane.com": 1,
  "mail2namibia.com": 1,
  "mail2nancy.com": 1,
  "mail2nasdaq.com": 1,
  "mail2nathan.com": 1,
  "mail2nauru.com": 1,
  "mail2navy.com": 1,
  "mail2neal.com": 1,
  "mail2nebraska.com": 1,
  "mail2ned.com": 1,
  "mail2neil.com": 1,
  "mail2nelson.com": 1,
  "mail2nemesis.com": 1,
  "mail2nepal.com": 1,
  "mail2netherlands.com": 1,
  "mail2network.com": 1,
  "mail2nevada.com": 1,
  "mail2newhampshire.com": 1,
  "mail2newjersey.com": 1,
  "mail2newmexico.com": 1,
  "mail2newyork.com": 1,
  "mail2newzealand.com": 1,
  "mail2nicaragua.com": 1,
  "mail2nick.com": 1,
  "mail2nicole.com": 1,
  "mail2niger.com": 1,
  "mail2nigeria.com": 1,
  "mail2nike.com": 1,
  "mail2no.com": 1,
  "mail2noah.com": 1,
  "mail2noel.com": 1,
  "mail2noelle.com": 1,
  "mail2normal.com": 1,
  "mail2norman.com": 1,
  "mail2northamerica.com": 1,
  "mail2northcarolina.com": 1,
  "mail2northdakota.com": 1,
  "mail2northpole.com": 1,
  "mail2norway.com": 1,
  "mail2notus.com": 1,
  "mail2noway.com": 1,
  "mail2nowhere.com": 1,
  "mail2nuclear.com": 1,
  "mail2nun.com": 1,
  "mail2ny.com": 1,
  "mail2oasis.com": 1,
  "mail2oceanographer.com": 1,
  "mail2ohio.com": 1,
  "mail2ok.com": 1,
  "mail2oklahoma.com": 1,
  "mail2oliver.com": 1,
  "mail2oman.com": 1,
  "mail2one.com": 1,
  "mail2onfire.com": 1,
  "mail2online.com": 1,
  "mail2oops.com": 1,
  "mail2open.com": 1,
  "mail2ophthalmologist.com": 1,
  "mail2optometrist.com": 1,
  "mail2oregon.com": 1,
  "mail2oscars.com": 1,
  "mail2oslo.com": 1,
  "mail2painter.com": 1,
  "mail2pakistan.com": 1,
  "mail2palau.com": 1,
  "mail2pan.com": 1,
  "mail2panama.com": 1,
  "mail2paraguay.com": 1,
  "mail2paralegal.com": 1,
  "mail2paris.com": 1,
  "mail2park.com": 1,
  "mail2parker.com": 1,
  "mail2party.com": 1,
  "mail2passion.com": 1,
  "mail2pat.com": 1,
  "mail2patricia.com": 1,
  "mail2patrick.com": 1,
  "mail2patty.com": 1,
  "mail2paul.com": 1,
  "mail2paula.com": 1,
  "mail2pay.com": 1,
  "mail2peace.com": 1,
  "mail2pediatrician.com": 1,
  "mail2peggy.com": 1,
  "mail2pennsylvania.com": 1,
  "mail2perry.com": 1,
  "mail2persephone.com": 1,
  "mail2persian.com": 1,
  "mail2peru.com": 1,
  "mail2pete.com": 1,
  "mail2peter.com": 1,
  "mail2pharmacist.com": 1,
  "mail2phil.com": 1,
  "mail2philippines.com": 1,
  "mail2phoenix.com": 1,
  "mail2phonecall.com": 1,
  "mail2phyllis.com": 1,
  "mail2pickup.com": 1,
  "mail2pilot.com": 1,
  "mail2pisces.com": 1,
  "mail2planet.com": 1,
  "mail2platinum.com": 1,
  "mail2plato.com": 1,
  "mail2pluto.com": 1,
  "mail2pm.com": 1,
  "mail2podiatrist.com": 1,
  "mail2poet.com": 1,
  "mail2poland.com": 1,
  "mail2policeman.com": 1,
  "mail2policewoman.com": 1,
  "mail2politician.com": 1,
  "mail2pop.com": 1,
  "mail2pope.com": 1,
  "mail2popular.com": 1,
  "mail2portugal.com": 1,
  "mail2poseidon.com": 1,
  "mail2potatohead.com": 1,
  "mail2power.com": 1,
  "mail2presbyterian.com": 1,
  "mail2president.com": 1,
  "mail2priest.com": 1,
  "mail2prince.com": 1,
  "mail2princess.com": 1,
  "mail2producer.com": 1,
  "mail2professor.com": 1,
  "mail2protect.com": 1,
  "mail2psychiatrist.com": 1,
  "mail2psycho.com": 1,
  "mail2psychologist.com": 1,
  "mail2qatar.com": 1,
  "mail2queen.com": 1,
  "mail2rabbi.com": 1,
  "mail2race.com": 1,
  "mail2racer.com": 1,
  "mail2rachel.com": 1,
  "mail2rage.com": 1,
  "mail2rainmaker.com": 1,
  "mail2ralph.com": 1,
  "mail2randy.com": 1,
  "mail2rap.com": 1,
  "mail2rare.com": 1,
  "mail2rave.com": 1,
  "mail2ray.com": 1,
  "mail2raymond.com": 1,
  "mail2realtor.com": 1,
  "mail2rebecca.com": 1,
  "mail2recruiter.com": 1,
  "mail2recycle.com": 1,
  "mail2redhead.com": 1,
  "mail2reed.com": 1,
  "mail2reggie.com": 1,
  "mail2register.com": 1,
  "mail2rent.com": 1,
  "mail2republican.com": 1,
  "mail2resort.com": 1,
  "mail2rex.com": 1,
  "mail2rhodeisland.com": 1,
  "mail2rich.com": 1,
  "mail2richard.com": 1,
  "mail2ricky.com": 1,
  "mail2ride.com": 1,
  "mail2riley.com": 1,
  "mail2rita.com": 1,
  "mail2rob.com": 1,
  "mail2robert.com": 1,
  "mail2roberta.com": 1,
  "mail2robin.com": 1,
  "mail2rock.com": 1,
  "mail2rocker.com": 1,
  "mail2rod.com": 1,
  "mail2rodney.com": 1,
  "mail2romania.com": 1,
  "mail2rome.com": 1,
  "mail2ron.com": 1,
  "mail2ronald.com": 1,
  "mail2ronnie.com": 1,
  "mail2rose.com": 1,
  "mail2rosie.com": 1,
  "mail2roy.com": 1,
  "mail2rss.org": 1,
  "mail2rudy.com": 1,
  "mail2rugby.com": 1,
  "mail2runner.com": 1,
  "mail2russell.com": 1,
  "mail2russia.com": 1,
  "mail2russian.com": 1,
  "mail2rusty.com": 1,
  "mail2ruth.com": 1,
  "mail2rwanda.com": 1,
  "mail2ryan.com": 1,
  "mail2sa.com": 1,
  "mail2sabrina.com": 1,
  "mail2safe.com": 1,
  "mail2sagittarius.com": 1,
  "mail2sail.com": 1,
  "mail2sailor.com": 1,
  "mail2sal.com": 1,
  "mail2salaam.com": 1,
  "mail2sam.com": 1,
  "mail2samantha.com": 1,
  "mail2samoa.com": 1,
  "mail2samurai.com": 1,
  "mail2sandra.com": 1,
  "mail2sandy.com": 1,
  "mail2sanfrancisco.com": 1,
  "mail2sanmarino.com": 1,
  "mail2santa.com": 1,
  "mail2sara.com": 1,
  "mail2sarah.com": 1,
  "mail2sat.com": 1,
  "mail2saturn.com": 1,
  "mail2saudi.com": 1,
  "mail2saudiarabia.com": 1,
  "mail2save.com": 1,
  "mail2savings.com": 1,
  "mail2school.com": 1,
  "mail2scientist.com": 1,
  "mail2scorpio.com": 1,
  "mail2scott.com": 1,
  "mail2sean.com": 1,
  "mail2search.com": 1,
  "mail2seattle.com": 1,
  "mail2secretagent.com": 1,
  "mail2senate.com": 1,
  "mail2senegal.com": 1,
  "mail2sensual.com": 1,
  "mail2seth.com": 1,
  "mail2sevenseas.com": 1,
  "mail2sexy.com": 1,
  "mail2seychelles.com": 1,
  "mail2shane.com": 1,
  "mail2sharon.com": 1,
  "mail2shawn.com": 1,
  "mail2ship.com": 1,
  "mail2shirley.com": 1,
  "mail2shoot.com": 1,
  "mail2shuttle.com": 1,
  "mail2sierraleone.com": 1,
  "mail2simon.com": 1,
  "mail2singapore.com": 1,
  "mail2single.com": 1,
  "mail2site.com": 1,
  "mail2skater.com": 1,
  "mail2skier.com": 1,
  "mail2sky.com": 1,
  "mail2sleek.com": 1,
  "mail2slim.com": 1,
  "mail2slovakia.com": 1,
  "mail2slovenia.com": 1,
  "mail2smile.com": 1,
  "mail2smith.com": 1,
  "mail2smooth.com": 1,
  "mail2soccer.com": 1,
  "mail2soccerfan.com": 1,
  "mail2socialist.com": 1,
  "mail2soldier.com": 1,
  "mail2somalia.com": 1,
  "mail2son.com": 1,
  "mail2song.com": 1,
  "mail2sos.com": 1,
  "mail2sound.com": 1,
  "mail2southafrica.com": 1,
  "mail2southamerica.com": 1,
  "mail2southcarolina.com": 1,
  "mail2southdakota.com": 1,
  "mail2southkorea.com": 1,
  "mail2southpole.com": 1,
  "mail2spain.com": 1,
  "mail2spanish.com": 1,
  "mail2spare.com": 1,
  "mail2spectrum.com": 1,
  "mail2splash.com": 1,
  "mail2sponsor.com": 1,
  "mail2sports.com": 1,
  "mail2srilanka.com": 1,
  "mail2stacy.com": 1,
  "mail2stan.com": 1,
  "mail2stanley.com": 1,
  "mail2star.com": 1,
  "mail2state.com": 1,
  "mail2stephanie.com": 1,
  "mail2steve.com": 1,
  "mail2steven.com": 1,
  "mail2stewart.com": 1,
  "mail2stlouis.com": 1,
  "mail2stock.com": 1,
  "mail2stockholm.com": 1,
  "mail2stockmarket.com": 1,
  "mail2storage.com": 1,
  "mail2store.com": 1,
  "mail2strong.com": 1,
  "mail2student.com": 1,
  "mail2studio.com": 1,
  "mail2studio54.com": 1,
  "mail2stuntman.com": 1,
  "mail2subscribe.com": 1,
  "mail2sudan.com": 1,
  "mail2superstar.com": 1,
  "mail2surfer.com": 1,
  "mail2suriname.com": 1,
  "mail2susan.com": 1,
  "mail2suzie.com": 1,
  "mail2swaziland.com": 1,
  "mail2sweden.com": 1,
  "mail2sweetheart.com": 1,
  "mail2swim.com": 1,
  "mail2swimmer.com": 1,
  "mail2swiss.com": 1,
  "mail2switzerland.com": 1,
  "mail2sydney.com": 1,
  "mail2sylvia.com": 1,
  "mail2syria.com": 1,
  "mail2taboo.com": 1,
  "mail2taiwan.com": 1,
  "mail2tajikistan.com": 1,
  "mail2tammy.com": 1,
  "mail2tango.com": 1,
  "mail2tanya.com": 1,
  "mail2tanzania.com": 1,
  "mail2tara.com": 1,
  "mail2taurus.com": 1,
  "mail2taxi.com": 1,
  "mail2taxidermist.com": 1,
  "mail2taylor.com": 1,
  "mail2taz.com": 1,
  "mail2teacher.com": 1,
  "mail2technician.com": 1,
  "mail2ted.com": 1,
  "mail2telephone.com": 1,
  "mail2teletubbie.com": 1,
  "mail2tenderness.com": 1,
  "mail2tennessee.com": 1,
  "mail2tennis.com": 1,
  "mail2tennisfan.com": 1,
  "mail2terri.com": 1,
  "mail2terry.com": 1,
  "mail2test.com": 1,
  "mail2texas.com": 1,
  "mail2thailand.com": 1,
  "mail2therapy.com": 1,
  "mail2think.com": 1,
  "mail2tickets.com": 1,
  "mail2tiffany.com": 1,
  "mail2tim.com": 1,
  "mail2time.com": 1,
  "mail2timothy.com": 1,
  "mail2tina.com": 1,
  "mail2titanic.com": 1,
  "mail2toby.com": 1,
  "mail2todd.com": 1,
  "mail2togo.com": 1,
  "mail2tom.com": 1,
  "mail2tommy.com": 1,
  "mail2tonga.com": 1,
  "mail2tony.com": 1,
  "mail2touch.com": 1,
  "mail2tourist.com": 1,
  "mail2tracey.com": 1,
  "mail2tracy.com": 1,
  "mail2tramp.com": 1,
  "mail2travel.com": 1,
  "mail2traveler.com": 1,
  "mail2travis.com": 1,
  "mail2trekkie.com": 1,
  "mail2trex.com": 1,
  "mail2triallawyer.com": 1,
  "mail2trick.com": 1,
  "mail2trillionaire.com": 1,
  "mail2troy.com": 1,
  "mail2truck.com": 1,
  "mail2trump.com": 1,
  "mail2try.com": 1,
  "mail2tunisia.com": 1,
  "mail2turbo.com": 1,
  "mail2turkey.com": 1,
  "mail2turkmenistan.com": 1,
  "mail2tv.com": 1,
  "mail2tycoon.com": 1,
  "mail2tyler.com": 1,
  "mail2u4me.com": 1,
  "mail2uae.com": 1,
  "mail2uganda.com": 1,
  "mail2uk.com": 1,
  "mail2ukraine.com": 1,
  "mail2uncle.com": 1,
  "mail2unsubscribe.com": 1,
  "mail2uptown.com": 1,
  "mail2uruguay.com": 1,
  "mail2usa.com": 1,
  "mail2utah.com": 1,
  "mail2uzbekistan.com": 1,
  "mail2v.com": 1,
  "mail2vacation.com": 1,
  "mail2valentines.com": 1,
  "mail2valerie.com": 1,
  "mail2valley.com": 1,
  "mail2vamoose.com": 1,
  "mail2vanessa.com": 1,
  "mail2vanuatu.com": 1,
  "mail2venezuela.com": 1,
  "mail2venous.com": 1,
  "mail2venus.com": 1,
  "mail2vermont.com": 1,
  "mail2vickie.com": 1,
  "mail2victor.com": 1,
  "mail2victoria.com": 1,
  "mail2vienna.com": 1,
  "mail2vietnam.com": 1,
  "mail2vince.com": 1,
  "mail2virginia.com": 1,
  "mail2virgo.com": 1,
  "mail2visionary.com": 1,
  "mail2vodka.com": 1,
  "mail2volleyball.com": 1,
  "mail2waiter.com": 1,
  "mail2wallstreet.com": 1,
  "mail2wally.com": 1,
  "mail2walter.com": 1,
  "mail2warren.com": 1,
  "mail2washington.com": 1,
  "mail2wave.com": 1,
  "mail2way.com": 1,
  "mail2waycool.com": 1,
  "mail2wayne.com": 1,
  "mail2webmaster.com": 1,
  "mail2webtop.com": 1,
  "mail2webtv.com": 1,
  "mail2weird.com": 1,
  "mail2wendell.com": 1,
  "mail2wendy.com": 1,
  "mail2westend.com": 1,
  "mail2westvirginia.com": 1,
  "mail2whether.com": 1,
  "mail2whip.com": 1,
  "mail2white.com": 1,
  "mail2whitehouse.com": 1,
  "mail2whitney.com": 1,
  "mail2why.com": 1,
  "mail2wilbur.com": 1,
  "mail2wild.com": 1,
  "mail2willard.com": 1,
  "mail2willie.com": 1,
  "mail2wine.com": 1,
  "mail2winner.com": 1,
  "mail2wired.com": 1,
  "mail2wisconsin.com": 1,
  "mail2woman.com": 1,
  "mail2wonder.com": 1,
  "mail2world.com": 1,
  "mail2worship.com": 1,
  "mail2wow.com": 1,
  "mail2www.com": 1,
  "mail2wyoming.com": 1,
  "mail2xfiles.com": 1,
  "mail2xox.com": 1,
  "mail2yachtclub.com": 1,
  "mail2yahalla.com": 1,
  "mail2yemen.com": 1,
  "mail2yes.com": 1,
  "mail2yugoslavia.com": 1,
  "mail2zack.com": 1,
  "mail2zambia.com": 1,
  "mail2zenith.com": 1,
  "mail2zephir.com": 1,
  "mail2zeus.com": 1,
  "mail2zipper.com": 1,
  "mail2zoo.com": 1,
  "mail2zoologist.com": 1,
  "mail2zurich.com": 1,
  "mail3000.com": 1,
  "mail333.com": 1,
  "mail4trash.com": 1,
  "mail4u.info": 1,
  "mailandftp.com": 1,
  "mailandnews.com": 1,
  "mailas.com": 1,
  "mailasia.com": 1,
  "mailbolt.com": 1,
  "mailbomb.net": 1,
  "mailboom.com": 1,
  "mailbox.as": 1,
  "mailbox.co.za": 1,
  "mailbox.gr": 1,
  "mailbox.hu": 1,
  "mailbox72.biz": 1,
  "mailbox80.biz": 1,
  "mailbr.com.br": 1,
  "mailc.net": 1,
  "mailcan.com": 1,
  "mailcat.biz": 1,
  "mailcc.com": 1,
  "mailchoose.co": 1,
  "mailcity.com": 1,
  "mailclub.fr": 1,
  "mailclub.net": 1,
  "maildrop.cc": 1,
  "maildrop.gq": 1,
  "maildx.com": 1,
  "mailed.ro": 1,
  "mailexcite.com": 1,
  "mailfa.tk": 1,
  "mailforce.net": 1,
  "mailforspam.com": 1,
  "mailfree.gq": 1,
  "mailfs.com": 1,
  "mailftp.com": 1,
  "mailgenie.net": 1,
  "mailguard.me": 1,
  "mailhaven.com": 1,
  "mailhood.com": 1,
  "mailimate.com": 1,
  "mailinator.com": 1,
  "mailinator.org": 1,
  "mailinator.us": 1,
  "mailinblack.com": 1,
  "mailingaddress.org": 1,
  "mailingweb.com": 1,
  "mailisent.com": 1,
  "mailismagic.com": 1,
  "mailite.com": 1,
  "mailmate.com": 1,
  "mailme.dk": 1,
  "mailme.gq": 1,
  "mailme24.com": 1,
  "mailmight.com": 1,
  "mailmij.nl": 1,
  "mailnator.com": 1,
  "mailnew.com": 1,
  "mailops.com": 1,
  "mailoye.com": 1,
  "mailpanda.com": 1,
  "mailpick.biz": 1,
  "mailpokemon.com": 1,
  "mailpost.zzn.com": 1,
  "mailpride.com": 1,
  "mailproxsy.com": 1,
  "mailpuppy.com": 1,
  "mailquack.com": 1,
  "mailrock.biz": 1,
  "mailroom.com": 1,
  "mailru.com": 1,
  "mailsac.com": 1,
  "mailseal.de": 1,
  "mailsent.net": 1,
  "mailservice.ms": 1,
  "mailshuttle.com": 1,
  "mailslapping.com": 1,
  "mailstart.com": 1,
  "mailstartplus.com": 1,
  "mailsurf.com": 1,
  "mailtag.com": 1,
  "mailtemp.info": 1,
  "mailto.de": 1,
  "mailtothis.com": 1,
  "mailueberfall.de": 1,
  "mailup.net": 1,
  "mailwire.com": 1,
  "mailworks.org": 1,
  "mailzi.ru": 1,
  "mailzilla.org": 1,
  "maktoob.com": 1,
  "malayalamtelevision.net": 1,
  "maltesemail.com": 1,
  "mamber.net": 1,
  "manager.de": 1,
  "mancity.net": 1,
  "mantrafreenet.com": 1,
  "mantramail.com": 1,
  "mantraonline.com": 1,
  "manybrain.com": 1,
  "marchmail.com": 1,
  "mariahc.com": 1,
  "marijuana.com": 1,
  "marijuana.nl": 1,
  "married-not.com": 1,
  "marsattack.com": 1,
  "martindalemail.com": 1,
  "mash4077.com": 1,
  "masrawy.com": 1,
  "matmail.com": 1,
  "mauimail.com": 1,
  "mauritius.com": 1,
  "maxleft.com": 1,
  "maxmail.co.uk": 1,
  "mbox.com.au": 1,
  "mchsi.com": 1,
  "me-mail.hu": 1,
  "me.com": 1,
  "medical.net.au": 1,
  "medscape.com": 1,
  "meetingmall.com": 1,
  "megago.com": 1,
  "megamail.pt": 1,
  "megapoint.com": 1,
  "mehrani.com": 1,
  "mehtaweb.com": 1,
  "meine-dateien.info": 1,
  "meine-diashow.de": 1,
  "meine-fotos.info": 1,
  "meine-urlaubsfotos.de": 1,
  "mekhong.com": 1,
  "melodymail.com": 1,
  "meloo.com": 1,
  "merda.flu.cc": 1,
  "merda.igg.biz": 1,
  "merda.nut.cc": 1,
  "merda.usa.cc": 1,
  "message.hu": 1,
  "message.myspace.com": 1,
  "messages.to": 1,
  "metacrawler.com": 1,
  "metalfan.com": 1,
  "metaping.com": 1,
  "metta.lk": 1,
  "mexicomail.com": 1,
  "mezimages.net": 1,
  "mfsa.ru": 1,
  "mierdamail.com": 1,
  "miesto.sk": 1,
  "mighty.co.za": 1,
  "migmail.net": 1,
  "migmail.pl": 1,
  "migumail.com": 1,
  "miho-nakayama.com": 1,
  "mikrotamanet.com": 1,
  "millionaireintraining.com": 1,
  "millionairemail.com": 1,
  "milmail.com": 1,
  "mindless.com": 1,
  "mindspring.com": 1,
  "minister.com": 1,
  "misery.net": 1,
  "mittalweb.com": 1,
  "mixmail.com": 1,
  "mjfrogmail.com": 1,
  "ml1.net": 1,
  "mlb.bounce.ed10.net": 1,
  "mm.st": 1,
  "mns.ru": 1,
  "moakt.com": 1,
  "mobilbatam.com": 1,
  "mobileninja.co.uk": 1,
  "mochamail.com": 1,
  "mohammed.com": 1,
  "mohmal.com": 1,
  "moldova.cc": 1,
  "moldova.com": 1,
  "moldovacc.com": 1,
  "momslife.com": 1,
  "monemail.com": 1,
  "money.net": 1,
  "montevideo.com.uy": 1,
  "monumentmail.com": 1,
  "moonman.com": 1,
  "moose-mail.com": 1,
  "mor19.uu.gl": 1,
  "mortaza.com": 1,
  "mosaicfx.com": 1,
  "moscowmail.com": 1,
  "most-wanted.com": 1,
  "mostlysunny.com": 1,
  "motormania.com": 1,
  "movemail.com": 1,
  "movieluver.com": 1,
  "mox.pp.ua": 1,
  "mp4.it": 1,
  "mr-potatohead.com": 1,
  "mscold.com": 1,
  "msgbox.com": 1,
  "msn.cn": 1,
  "msn.com": 1,
  "msn.nl": 1,
  "mt2015.com": 1,
  "mt2016.com": 1,
  "mttestdriver.com": 1,
  "muehlacker.tk": 1,
  "muell.icu": 1,
  "muellmail.com": 1,
  "muellemail.com": 1,
  "mundomail.net": 1,
  "munich.com": 1,
  "music.com": 1,
  "musician.org": 1,
  "musicscene.org": 1,
  "muskelshirt.de": 1,
  "muslim.com": 1,
  "muslimsonline.com": 1,
  "mutantweb.com": 1,
  "mvrht.com": 1,
  "my.com": 1,
  "my10minutemail.com": 1,
  "mybox.it": 1,
  "mycabin.com": 1,
  "mycity.com": 1,
  "mycool.com": 1,
  "mydomain.com": 1,
  "mydotcomaddress.com": 1,
  "myfamily.com": 1,
  "myfastmail.com": 1,
  "mygo.com": 1,
  "myiris.com": 1,
  "mymacmail.com": 1,
  "mynamedot.com": 1,
  "mynet.com": 1,
  "mynetaddress.com": 1,
  "mynetstore.de": 1,
  "myownemail.com": 1,
  "myownfriends.com": 1,
  "mypacks.net": 1,
  "mypad.com": 1,
  "mypersonalemail.com": 1,
  "myplace.com": 1,
  "myrambler.ru": 1,
  "myrealbox.com": 1,
  "myremarq.com": 1,
  "myself.com": 1,
  "myspaceinc.net": 1,
  "myspamless.com": 1,
  "mystupidjob.com": 1,
  "mytemp.email": 1,
  "mythirdage.com": 1,
  "myway.com": 1,
  "myworldmail.com": 1,
  "n2.com": 1,
  "n2baseball.com": 1,
  "n2business.com": 1,
  "n2mail.com": 1,
  "n2soccer.com": 1,
  "n2software.com": 1,
  "nabc.biz": 1,
  "nafe.com": 1,
  "nagpal.net": 1,
  "nakedgreens.com": 1,
  "name.com": 1,
  "nameplanet.com": 1,
  "nandomail.com": 1,
  "naplesnews.net": 1,
  "naseej.com": 1,
  "nativestar.net": 1,
  "nativeweb.net": 1,
  "naui.net": 1,
  "naver.com": 1,
  "navigator.lv": 1,
  "navy.org": 1,
  "naz.com": 1,
  "nc.rr.com": 1,
  "nchoicemail.com": 1,
  "neeva.net": 1,
  "nemra1.com": 1,
  "nenter.com": 1,
  "neo.rr.com": 1,
  "nervhq.org": 1,
  "net-c.be": 1,
  "net-c.ca": 1,
  "net-c.cat": 1,
  "net-c.com": 1,
  "net-c.es": 1,
  "net-c.fr": 1,
  "net-c.it": 1,
  "net-c.lu": 1,
  "net-c.nl": 1,
  "net-c.pl": 1,
  "net-pager.net": 1,
  "net-shopping.com": 1,
  "net4b.pt": 1,
  "net4you.at": 1,
  "netbounce.com": 1,
  "netbroadcaster.com": 1,
  "netby.dk": 1,
  "netc.eu": 1,
  "netc.fr": 1,
  "netc.it": 1,
  "netc.lu": 1,
  "netc.pl": 1,
  "netcenter-vn.net": 1,
  "netcmail.com": 1,
  "netcourrier.com": 1,
  "netexecutive.com": 1,
  "netexpressway.com": 1,
  "netgenie.com": 1,
  "netian.com": 1,
  "netizen.com.ar": 1,
  "netlane.com": 1,
  "netlimit.com": 1,
  "netmongol.com": 1,
  "netnet.com.sg": 1,
  "netnoir.net": 1,
  "netpiper.com": 1,
  "netposta.net": 1,
  "netralink.com": 1,
  "netscape.net": 1,
  "netscapeonline.co.uk": 1,
  "netspace.net.au": 1,
  "netspeedway.com": 1,
  "netsquare.com": 1,
  "netster.com": 1,
  "nettaxi.com": 1,
  "nettemail.com": 1,
  "netterchef.de": 1,
  "netti.fi": 1,
  "netzero.com": 1,
  "netzero.net": 1,
  "netzidiot.de": 1,
  "neue-dateien.de": 1,
  "neuro.md": 1,
  "newmail.com": 1,
  "newmail.net": 1,
  "newmail.ru": 1,
  "newsboysmail.com": 1,
  "newyork.com": 1,
  "nextmail.ru": 1,
  "nexxmail.com": 1,
  "nfmail.com": 1,
  "nicebush.com": 1,
  "nicegal.com": 1,
  "nicholastse.net": 1,
  "nicolastse.com": 1,
  "nightmail.com": 1,
  "nikopage.com": 1,
  "nimail.com": 1,
  "ninfan.com": 1,
  "nirvanafan.com": 1,
  "nmail.cf": 1,
  "noavar.com": 1,
  "nonpartisan.com": 1,
  "nonspam.eu": 1,
  "nonspammer.de": 1,
  "norika-fujiwara.com": 1,
  "norikomail.com": 1,
  "northgates.net": 1,
  "nospammail.net": 1,
  "nospamthanks.info": 1,
  "nowhere.org": 1,
  "ntelos.net": 1,
  "ntlhelp.net": 1,
  "ntlworld.com": 1,
  "ntscan.com": 1,
  "null.net": 1,
  "nullbox.info": 1,
  "nur-fuer-spam.de": 1,
  "nus.edu.sg": 1,
  "nwldx.com": 1,
  "nwytg.net": 1,
  "nxt.ru": 1,
  "ny.com": 1,
  "nybella.com": 1,
  "nyc.com": 1,
  "nycmail.com": 1,
  "nzoomail.com": 1,
  "o-tay.com": 1,
  "o2.co.uk": 1,
  "oaklandas-fan.com": 1,
  "oath.com": 1,
  "oceanfree.net": 1,
  "odaymail.com": 1,
  "oddpost.com": 1,
  "odmail.com": 1,
  "office-dateien.de": 1,
  "office-email.com": 1,
  "offroadwarrior.com": 1,
  "oicexchange.com": 1,
  "oida.icu": 1,
  "oikrach.com": 1,
  "okbank.com": 1,
  "okhuman.com": 1,
  "okmad.com": 1,
  "okmagic.com": 1,
  "okname.net": 1,
  "okuk.com": 1,
  "oldies104mail.com": 1,
  "ole.com": 1,
  "olemail.com": 1,
  "olympist.net": 1,
  "olypmall.ru": 1,
  "omaninfo.com": 1,
  "omen.ru": 1,
  "onebox.com": 1,
  "onenet.com.ar": 1,
  "oneoffmail.com": 1,
  "onet.com.pl": 1,
  "onet.eu": 1,
  "onet.pl": 1,
  "oninet.pt": 1,
  "online.ie": 1,
  "online.ms": 1,
  "online.nl": 1,
  "onlinewiz.com": 1,
  "onmilwaukee.com": 1,
  "onobox.com": 1,
  "op.pl": 1,
  "opayq.com": 1,
  "openmailbox.org": 1,
  "operafan.com": 1,
  "operamail.com": 1,
  "opoczta.pl": 1,
  "optician.com": 1,
  "optonline.net": 1,
  "optusnet.com.au": 1,
  "orange.fr": 1,
  "orbitel.bg": 1,
  "orgmail.net": 1,
  "orthodontist.net": 1,
  "osite.com.br": 1,
  "oso.com": 1,
  "otakumail.com": 1,
  "our-computer.com": 1,
  "our-office.com": 1,
  "our.st": 1,
  "ourbrisbane.com": 1,
  "ourklips.com": 1,
  "ournet.md": 1,
  "outgun.com": 1,
  "outlawspam.com": 1,
  "outlook.at": 1,
  "outlook.be": 1,
  "outlook.cl": 1,
  "outlook.co.id": 1,
  "outlook.co.il": 1,
  "outlook.co.nz": 1,
  "outlook.co.th": 1,
  "outlook.com": 1,
  "outlook.com.au": 1,
  "outlook.com.br": 1,
  "outlook.com.gr": 1,
  "outlook.com.pe": 1,
  "outlook.com.tr": 1,
  "outlook.com.vn": 1,
  "outlook.cz": 1,
  "outlook.de": 1,
  "outlook.dk": 1,
  "outlook.es": 1,
  "outlook.fr": 1,
  "outlook.hu": 1,
  "outlook.ie": 1,
  "outlook.in": 1,
  "outlook.it": 1,
  "outlook.jp": 1,
  "outlook.kr": 1,
  "outlook.lv": 1,
  "outlook.my": 1,
  "outlook.nl": 1,
  "outlook.ph": 1,
  "outlook.pt": 1,
  "outlook.sa": 1,
  "outlook.sg": 1,
  "outlook.sk": 1,
  "over-the-rainbow.com": 1,
  "ownmail.net": 1,
  "ozbytes.net.au": 1,
  "ozemail.com.au": 1,
  "pacbell.net": 1,
  "pacific-ocean.com": 1,
  "pacific-re.com": 1,
  "pacificwest.com": 1,
  "packersfan.com": 1,
  "pagina.de": 1,
  "pagons.org": 1,
  "pakistanmail.com": 1,
  "pakistanoye.com": 1,
  "palestinemail.com": 1,
  "pandora.be": 1,
  "papierkorb.me": 1,
  "parkjiyoon.com": 1,
  "parsmail.com": 1,
  "partlycloudy.com": 1,
  "partybombe.de": 1,
  "partyheld.de": 1,
  "partynight.at": 1,
  "parvazi.com": 1,
  "passwordmail.com": 1,
  "pathfindermail.com": 1,
  "pconnections.net": 1,
  "pcpostal.com": 1,
  "pcsrock.com": 1,
  "pcusers.otherinbox.com": 1,
  "pediatrician.com": 1,
  "penpen.com": 1,
  "peoplepc.com": 1,
  "peopleweb.com": 1,
  "pepbot.com": 1,
  "perfectmail.com": 1,
  "perso.be": 1,
  "personal.ro": 1,
  "personales.com": 1,
  "petlover.com": 1,
  "petml.com": 1,
  "pettypool.com": 1,
  "pezeshkpour.com": 1,
  "pfui.ru": 1,
  "phayze.com": 1,
  "phone.net": 1,
  "photo-impact.eu": 1,
  "photographer.net": 1,
  "phpbb.uu.gl": 1,
  "phreaker.net": 1,
  "phus8kajuspa.cu.cc": 1,
  "physicist.net": 1,
  "pianomail.com": 1,
  "pickupman.com": 1,
  "picusnet.com": 1,
  "pigpig.net": 1,
  "pinoymail.com": 1,
  "piracha.net": 1,
  "pisem.net": 1,
  "pjjkp.com": 1,
  "planet.nl": 1,
  "planetaccess.com": 1,
  "planetarymotion.net": 1,
  "planetearthinter.net": 1,
  "planetmail.com": 1,
  "planetmail.net": 1,
  "planetout.com": 1,
  "plasa.com": 1,
  "playersodds.com": 1,
  "playful.com": 1,
  "playstation.sony.com": 1,
  "plus.com": 1,
  "plus.google.com": 1,
  "plusmail.com.br": 1,
  "pmail.net": 1,
  "pobox.hu": 1,
  "pobox.sk": 1,
  "pochta.ru": 1,
  "poczta.fm": 1,
  "poczta.onet.pl": 1,
  "poetic.com": 1,
  "pokemail.net": 1,
  "pokemonpost.com": 1,
  "pokepost.com": 1,
  "polandmail.com": 1,
  "polbox.com": 1,
  "policeoffice.com": 1,
  "politician.com": 1,
  "polizisten-duzer.de": 1,
  "polyfaust.com": 1,
  "pool-sharks.com": 1,
  "poond.com": 1,
  "popaccount.com": 1,
  "popmail.com": 1,
  "popsmail.com": 1,
  "popstar.com": 1,
  "portugalmail.com": 1,
  "portugalmail.pt": 1,
  "portugalnet.com": 1,
  "positive-thinking.com": 1,
  "post.com": 1,
  "post.cz": 1,
  "post.sk": 1,
  "posta.ro": 1,
  "postaccesslite.com": 1,
  "postafree.com": 1,
  "postaweb.com": 1,
  "posteo.de": 1,
  "postfach.cc": 1,
  "postinbox.com": 1,
  "postino.ch": 1,
  "postmark.net": 1,
  "postmaster.co.uk": 1,
  "postmaster.twitter.com": 1,
  "postpro.net": 1,
  "pousa.com": 1,
  "powerfan.com": 1,
  "pp.inet.fi": 1,
  "praize.com": 1,
  "premium-mail.fr": 1,
  "premiumservice.com": 1,
  "presidency.com": 1,
  "press.co.jp": 1,
  "priest.com": 1,
  "primposta.com": 1,
  "primposta.hu": 1,
  "privy-mail.com": 1,
  "privymail.de": 1,
  "pro.hu": 1,
  "probemail.com": 1,
  "prodigy.net": 1,
  "progetplus.it": 1,
  "programist.ru": 1,
  "programmer.net": 1,
  "programozo.hu": 1,
  "proinbox.com": 1,
  "project2k.com": 1,
  "promessage.com": 1,
  "prontomail.com": 1,
  "protestant.com": 1,
  "protonmail.com": 1,
  "prydirect.info": 1,
  "psv-supporter.com": 1,
  "ptd.net": 1,
  "public-files.de": 1,
  "public.usa.com": 1,
  "publicist.com": 1,
  "pulp-fiction.com": 1,
  "punkass.com": 1,
  "purpleturtle.com": 1,
  "put2.net": 1,
  "pwrby.com": 1,
  "q.com": 1,
  "qatarmail.com": 1,
  "qmail.com": 1,
  "qprfans.com": 1,
  "qq.com": 1,
  "qrio.com": 1,
  "quackquack.com": 1,
  "quakemail.com": 1,
  "qualityservice.com": 1,
  "quantentunnel.de": 1,
  "qudsmail.com": 1,
  "quepasa.com": 1,
  "quickhosts.com": 1,
  "quickmail.nl": 1,
  "quicknet.nl": 1,
  "quickwebmail.com": 1,
  "quiklinks.com": 1,
  "quikmail.com": 1,
  "qv7.info": 1,
  "qwest.net": 1,
  "qwestoffice.net": 1,
  "r-o-o-t.com": 1,
  "raakim.com": 1,
  "racedriver.com": 1,
  "racefanz.com": 1,
  "racingfan.com.au": 1,
  "racingmail.com": 1,
  "radicalz.com": 1,
  "radiku.ye.vc": 1,
  "radiologist.net": 1,
  "ragingbull.com": 1,
  "ralib.com": 1,
  "rambler.ru": 1,
  "ranmamail.com": 1,
  "rastogi.net": 1,
  "ratt-n-roll.com": 1,
  "rattle-snake.com": 1,
  "raubtierbaendiger.de": 1,
  "ravearena.com": 1,
  "ravemail.com": 1,
  "razormail.com": 1,
  "rccgmail.org": 1,
  "rcn.com": 1,
  "realemail.net": 1,
  "reality-concept.club": 1,
  "reallyfast.biz": 1,
  "reallyfast.info": 1,
  "reallymymail.com": 1,
  "realradiomail.com": 1,
  "realtyagent.com": 1,
  "reborn.com": 1,
  "reconmail.com": 1,
  "recycler.com": 1,
  "recyclermail.com": 1,
  "rediff.com": 1,
  "rediffmail.com": 1,
  "rediffmailpro.com": 1,
  "rednecks.com": 1,
  "redseven.de": 1,
  "redsfans.com": 1,
  "regbypass.com": 1,
  "reggaefan.com": 1,
  "registerednurses.com": 1,
  "regspaces.tk": 1,
  "reincarnate.com": 1,
  "religious.com": 1,
  "remail.ga": 1,
  "renren.com": 1,
  "repairman.com": 1,
  "reply.hu": 1,
  "reply.ticketmaster.com": 1,
  "representative.com": 1,
  "rescueteam.com": 1,
  "resgedvgfed.tk": 1,
  "resource.calendar.google.com": 1,
  "resumemail.com": 1,
  "rezai.com": 1,
  "rhyta.com": 1,
  "richmondhill.com": 1,
  "rickymail.com": 1,
  "rin.ru": 1,
  "riopreto.com.br": 1,
  "rklips.com": 1,
  "rn.com": 1,
  "ro.ru": 1,
  "roadrunner.com": 1,
  "roanokemail.com": 1,
  "rock.com": 1,
  "rocketmail.com": 1,
  "rocketship.com": 1,
  "rockfan.com": 1,
  "rodrun.com": 1,
  "rogers.com": 1,
  "rome.com": 1,
  "roosh.com": 1,
  "rootprompt.org": 1,
  "roughnet.com": 1,
  "royal.net": 1,
  "rr.com": 1,
  "rrohio.com": 1,
  "rsub.com": 1,
  "rubyridge.com": 1,
  "runbox.com": 1,
  "rushpost.com": 1,
  "ruttolibero.com": 1,
  "rvshop.com": 1,
  "s-mail.com": 1,
  "sabreshockey.com": 1,
  "sacbeemail.com": 1,
  "saeuferleber.de": 1,
  "safe-mail.net": 1,
  "safrica.com": 1,
  "sagra.lu": 1,
  "sags-per-mail.de": 1,
  "sailormoon.com": 1,
  "saintly.com": 1,
  "saintmail.net": 1,
  "sale-sale-sale.com": 1,
  "salehi.net": 1,
  "salesperson.net": 1,
  "samerica.com": 1,
  "samilan.net": 1,
  "sammimail.com": 1,
  "sandelf.de": 1,
  "sanfranmail.com": 1,
  "sanook.com": 1,
  "sapo.pt": 1,
  "saudia.com": 1,
  "savelife.ml": 1,
  "sayhi.net": 1,
  "saynotospams.com": 1,
  "sbcglbal.net": 1,
  "sbcglobal.com": 1,
  "sbcglobal.net": 1,
  "scandalmail.com": 1,
  "scarlet.nl": 1,
  "schafmail.de": 1,
  "schizo.com": 1,
  "schmusemail.de": 1,
  "schoolemail.com": 1,
  "schoolmail.com": 1,
  "schoolsucks.com": 1,
  "schreib-doch-mal-wieder.de": 1,
  "schweiz.org": 1,
  "sci.fi": 1,
  "scientist.com": 1,
  "scifianime.com": 1,
  "scotland.com": 1,
  "scotlandmail.com": 1,
  "scottishmail.co.uk": 1,
  "scottsboro.org": 1,
  "scubadiving.com": 1,
  "seanet.com": 1,
  "search.ua": 1,
  "searchwales.com": 1,
  "sebil.com": 1,
  "seckinmail.com": 1,
  "secret-police.com": 1,
  "secretary.net": 1,
  "secretservices.net": 1,
  "secure-mail.biz": 1,
  "secure-mail.cc": 1,
  "seductive.com": 1,
  "seekstoyboy.com": 1,
  "seguros.com.br": 1,
  "selfdestructingmail.com": 1,
  "send.hu": 1,
  "sendme.cz": 1,
  "sendspamhere.com": 1,
  "sent.as": 1,
  "sent.at": 1,
  "sent.com": 1,
  "sentrismail.com": 1,
  "serga.com.ar": 1,
  "servemymail.com": 1,
  "servermaps.net": 1,
  "sesmail.com": 1,
  "sexmagnet.com": 1,
  "seznam.cz": 1,
  "shahweb.net": 1,
  "shaniastuff.com": 1,
  "shared-files.de": 1,
  "sharedmailbox.org": 1,
  "sharmaweb.com": 1,
  "shaw.ca": 1,
  "she.com": 1,
  "shieldedmail.com": 1,
  "shinedyoureyes.com": 1,
  "shitaway.cf": 1,
  "shitaway.cu.cc": 1,
  "shitaway.ga": 1,
  "shitaway.gq": 1,
  "shitaway.ml": 1,
  "shitaway.tk": 1,
  "shitaway.usa.cc": 1,
  "shitmail.de": 1,
  "shitmail.org": 1,
  "shitware.nl": 1,
  "shockinmytown.cu.cc": 1,
  "shootmail.com": 1,
  "shortmail.com": 1,
  "shotgun.hu": 1,
  "showslow.de": 1,
  "shuf.com": 1,
  "sialkotcity.com": 1,
  "sialkotian.com": 1,
  "sialkotoye.com": 1,
  "sify.com": 1,
  "silkroad.net": 1,
  "sina.cn": 1,
  "sina.com": 1,
  "sinamail.com": 1,
  "singapore.com": 1,
  "singles4jesus.com": 1,
  "singmail.com": 1,
  "singnet.com.sg": 1,
  "sinnlos-mail.de": 1,
  "siteposter.net": 1,
  "skafan.com": 1,
  "skeefmail.com": 1,
  "skim.com": 1,
  "skizo.hu": 1,
  "skrx.tk": 1,
  "sky.com": 1,
  "skynet.be": 1,
  "slamdunkfan.com": 1,
  "slave-auctions.net": 1,
  "slingshot.com": 1,
  "slippery.email": 1,
  "slipry.net": 1,
  "slo.net": 1,
  "slotter.com": 1,
  "smap.4nmv.ru": 1,
  "smapxsmap.net": 1,
  "smashmail.de": 1,
  "smellrear.com": 1,
  "smileyface.comsmithemail.net": 1,
  "smoothmail.com": 1,
  "sms.at": 1,
  "snail-mail.net": 1,
  "snakebite.com": 1,
  "snakemail.com": 1,
  "sndt.net": 1,
  "sneakemail.com": 1,
  "snet.net": 1,
  "sniper.hu": 1,
  "snkmail.com": 1,
  "snoopymail.com": 1,
  "snowboarding.com": 1,
  "snowdonia.net": 1,
  "socamail.com": 1,
  "socceramerica.net": 1,
  "soccermail.com": 1,
  "soccermomz.com": 1,
  "social-mailer.tk": 1,
  "socialworker.net": 1,
  "sociologist.com": 1,
  "sofort-mail.de": 1,
  "sofortmail.de": 1,
  "softhome.net": 1,
  "sogou.com": 1,
  "sohu.com": 1,
  "sol.dk": 1,
  "solar-impact.pro": 1,
  "solcon.nl": 1,
  "soldier.hu": 1,
  "solution4u.com": 1,
  "solvemail.info": 1,
  "songwriter.net": 1,
  "sonnenkinder.org": 1,
  "soodomail.com": 1,
  "soon.com": 1,
  "soulfoodcookbook.com": 1,
  "sp.nl": 1,
  "space-bank.com": 1,
  "space-man.com": 1,
  "space-ship.com": 1,
  "space-travel.com": 1,
  "space.com": 1,
  "spacemart.com": 1,
  "spacetowns.com": 1,
  "spacewar.com": 1,
  "spainmail.com": 1,
  "spam.2012-2016.ru": 1,
  "spamavert.com": 1,
  "spambob.com": 1,
  "spambob.org": 1,
  "spambog.net": 1,
  "spambooger.com": 1,
  "spam.care": 1,
  "spamcero.com": 1,
  "spamdecoy.net": 1,
  "spameater.com": 1,
  "spameater.org": 1,
  "spamex.com": 1,
  "spamfree24.info": 1,
  "spamfree24.net": 1,
  "spamgoes.in": 1,
  "spaminator.de": 1,
  "spamkill.info": 1,
  "spaml.com": 1,
  "spamoff.de": 1,
  "spamstack.net": 1,
  "spartapiet.com": 1,
  "spazmail.com": 1,
  "speedemail.net": 1,
  "speedpost.net": 1,
  "speedrules.com": 1,
  "speedrulz.com": 1,
  "speedymail.org": 1,
  "sperke.net": 1,
  "spils.com": 1,
  "spinfinder.com": 1,
  "spl.at": 1,
  "spoko.pl": 1,
  "spoofmail.de": 1,
  "sportemail.com": 1,
  "sportsmail.com": 1,
  "sporttruckdriver.com": 1,
  "spray.no": 1,
  "spray.se": 1,
  "spybox.de": 1,
  "spymac.com": 1,
  "sraka.xyz": 1,
  "srilankan.net": 1,
  "ssl-mail.com": 1,
  "st-davids.net": 1,
  "stade.fr": 1,
  "stalag13.com": 1,
  "stargateradio.com": 1,
  "starmail.com": 1,
  "starmail.org": 1,
  "starmedia.com": 1,
  "starplace.com": 1,
  "starspath.com": 1,
  "start.com.au": 1,
  "startkeys.com": 1,
  "stinkefinger.net": 1,
  "stipte.nl": 1,
  "stoned.com": 1,
  "stones.com": 1,
  "stop-my-spam.pp.ua": 1,
  "stopdropandroll.com": 1,
  "storksite.com": 1,
  "streber24.de": 1,
  "streetwisemail.com": 1,
  "stribmail.com": 1,
  "strompost.com": 1,
  "strongguy.com": 1,
  "student.su": 1,
  "studentcenter.org": 1,
  "stuffmail.de": 1,
  "subram.com": 1,
  "sudanmail.net": 1,
  "sudolife.me": 1,
  "sudolife.net": 1,
  "sudomail.biz": 1,
  "sudomail.com": 1,
  "sudomail.net": 1,
  "sudoverse.com": 1,
  "sudoverse.net": 1,
  "sudoweb.net": 1,
  "sudoworld.com": 1,
  "sudoworld.net": 1,
  "suhabi.com": 1,
  "suisse.org": 1,
  "sukhumvit.net": 1,
  "sunpoint.net": 1,
  "sunrise-sunset.com": 1,
  "sunsgame.com": 1,
  "sunumail.sn": 1,
  "suomi24.fi": 1,
  "superdada.com": 1,
  "supereva.it": 1,
  "supermail.ru": 1,
  "superrito.com": 1,
  "superstachel.de": 1,
  "surat.com": 1,
  "surf3.net": 1,
  "surfree.com": 1,
  "surfy.net": 1,
  "surgical.net": 1,
  "surimail.com": 1,
  "survivormail.com": 1,
  "susi.ml": 1,
  "svk.jp": 1,
  "swbell.net": 1,
  "sweb.cz": 1,
  "swedenmail.com": 1,
  "sweetville.net": 1,
  "sweetxxx.de": 1,
  "swift-mail.com": 1,
  "swiftdesk.com": 1,
  "swingeasyhithard.com": 1,
  "swingfan.com": 1,
  "swipermail.zzn.com": 1,
  "swirve.com": 1,
  "swissinfo.org": 1,
  "swissmail.com": 1,
  "swissmail.net": 1,
  "switchboardmail.com": 1,
  "switzerland.org": 1,
  "sx172.com": 1,
  "syom.com": 1,
  "syriamail.com": 1,
  "t-online.de": 1,
  "t.psh.me": 1,
  "t2mail.com": 1,
  "tafmail.com": 1,
  "takuyakimura.com": 1,
  "talk21.com": 1,
  "talkcity.com": 1,
  "talkinator.com": 1,
  "tamil.com": 1,
  "tampabay.rr.com": 1,
  "tankpolice.com": 1,
  "tatanova.com": 1,
  "tbwt.com": 1,
  "tcc.on.ca": 1,
  "tds.net": 1,
  "teachermail.net": 1,
  "teachers.org": 1,
  "teamdiscovery.com": 1,
  "teamtulsa.net": 1,
  "tech-center.com": 1,
  "tech4peace.org": 1,
  "techemail.com": 1,
  "techie.com": 1,
  "technisamail.co.za": 1,
  "technologist.com": 1,
  "techscout.com": 1,
  "techspot.com": 1,
  "teenagedirtbag.com": 1,
  "tele2.nl": 1,
  "telebot.com": 1,
  "telefonica.net": 1,
  "teleline.es": 1,
  "telenet.be": 1,
  "telepac.pt": 1,
  "telerymd.com": 1,
  "teleworm.us": 1,
  "telfort.nl": 1,
  "telfortglasvezel.nl": 1,
  "telinco.net": 1,
  "telkom.net": 1,
  "telpage.net": 1,
  "telstra.com": 1,
  "telstra.com.au": 1,
  "temp-mail.com": 1,
  "temp-mail.de": 1,
  "temp.headstrong.de": 1,
  "tempail.com": 1,
  "tempemail.biz": 1,
  "tempmail.us": 1,
  "tempmail2.com": 1,
  "tempmaildemo.com": 1,
  "tempmailer.com": 1,
  "temporarioemail.com.br": 1,
  "temporaryemail.us": 1,
  "tempthe.net": 1,
  "tempymail.com": 1,
  "temtulsa.net": 1,
  "tenchiclub.com": 1,
  "tenderkiss.com": 1,
  "tennismail.com": 1,
  "terminverpennt.de": 1,
  "terra.cl": 1,
  "terra.com": 1,
  "terra.com.ar": 1,
  "terra.com.br": 1,
  "terra.es": 1,
  "test.com": 1,
  "test.de": 1,
  "tfanus.com.er": 1,
  "tfz.net": 1,
  "thai.com": 1,
  "thaimail.com": 1,
  "thaimail.net": 1,
  "thanksnospam.info": 1,
  "the-african.com": 1,
  "the-airforce.com": 1,
  "the-aliens.com": 1,
  "the-american.com": 1,
  "the-animal.com": 1,
  "the-army.com": 1,
  "the-astronaut.com": 1,
  "the-beauty.com": 1,
  "the-big-apple.com": 1,
  "the-biker.com": 1,
  "the-boss.com": 1,
  "the-brazilian.com": 1,
  "the-canadian.com": 1,
  "the-canuck.com": 1,
  "the-captain.com": 1,
  "the-chinese.com": 1,
  "the-country.com": 1,
  "the-cowboy.com": 1,
  "the-davis-home.com": 1,
  "the-dutchman.com": 1,
  "the-eagles.com": 1,
  "the-englishman.com": 1,
  "the-fastest.net": 1,
  "the-fool.com": 1,
  "the-frenchman.com": 1,
  "the-galaxy.net": 1,
  "the-genius.com": 1,
  "the-gentleman.com": 1,
  "the-german.com": 1,
  "the-gremlin.com": 1,
  "the-hooligan.com": 1,
  "the-italian.com": 1,
  "the-japanese.com": 1,
  "the-lair.com": 1,
  "the-madman.com": 1,
  "the-mailinglist.com": 1,
  "the-marine.com": 1,
  "the-master.com": 1,
  "the-mexican.com": 1,
  "the-ministry.com": 1,
  "the-monkey.com": 1,
  "the-newsletter.net": 1,
  "the-pentagon.com": 1,
  "the-police.com": 1,
  "the-prayer.com": 1,
  "the-professional.com": 1,
  "the-quickest.com": 1,
  "the-russian.com": 1,
  "the-snake.com": 1,
  "the-spaceman.com": 1,
  "the-stock-market.com": 1,
  "the-student.net": 1,
  "the-whitehouse.net": 1,
  "the-wild-west.com": 1,
  "the18th.com": 1,
  "thecoolguy.com": 1,
  "thecriminals.com": 1,
  "thedoghousemail.com": 1,
  "thedorm.com": 1,
  "theend.hu": 1,
  "theglobe.com": 1,
  "thegolfcourse.com": 1,
  "thegooner.com": 1,
  "theheadoffice.com": 1,
  "theinternetemail.com": 1,
  "thelanddownunder.com": 1,
  "themail.com": 1,
  "themillionare.net": 1,
  "theoffice.net": 1,
  "theplate.com": 1,
  "thepokerface.com": 1,
  "thepostmaster.net": 1,
  "theraces.com": 1,
  "theracetrack.com": 1,
  "therapist.net": 1,
  "thestreetfighter.com": 1,
  "theteebox.com": 1,
  "thewatercooler.com": 1,
  "thewebpros.co.uk": 1,
  "thewizzard.com": 1,
  "thewizzkid.com": 1,
  "thezhangs.net": 1,
  "thirdage.com": 1,
  "thisgirl.com": 1,
  "thraml.com": 1,
  "throwam.com": 1,
  "thundermail.com": 1,
  "tidni.com": 1,
  "timein.net": 1,
  "tiscali.at": 1,
  "tiscali.be": 1,
  "tiscali.co.uk": 1,
  "tiscali.it": 1,
  "tiscali.lu": 1,
  "tiscali.se": 1,
  "tkcity.com": 1,
  "tmail.ws": 1,
  "toast.com": 1,
  "toke.com": 1,
  "tom.com": 1,
  "toolsource.com": 1,
  "toomail.biz": 1,
  "toothfairy.com": 1,
  "topchat.com": 1,
  "topgamers.co.uk": 1,
  "topletter.com": 1,
  "topmail-files.de": 1,
  "topmail.com.ar": 1,
  "topsurf.com": 1,
  "torchmail.com": 1,
  "torontomail.com": 1,
  "tortenboxer.de": 1,
  "totalmail.de": 1,
  "totalmusic.net": 1,
  "townisp.com": 1,
  "tpg.com.au": 1,
  "trash-amil.com": 1,
  "trash-mail.ga": 1,
  "trash-mail.ml": 1,
  "trash2010.com": 1,
  "trash2011.com": 1,
  "trashdevil.de": 1,
  "trashymail.net": 1,
  "travel.li": 1,
  "trayna.com": 1,
  "trialbytrivia.com": 1,
  "trickmail.net": 1,
  "trimix.cn": 1,
  "tritium.net": 1,
  "trmailbox.com": 1,
  "tropicalstorm.com": 1,
  "truckerz.com": 1,
  "truckracer.com": 1,
  "truckracers.com": 1,
  "trust-me.com": 1,
  "truthmail.com": 1,
  "tsamail.co.za": 1,
  "ttml.co.in": 1,
  "tunisiamail.com": 1,
  "turboprinz.de": 1,
  "turboprinzessin.de": 1,
  "turkey.com": 1,
  "turual.com": 1,
  "tut.by": 1,
  "tvstar.com": 1,
  "twc.com": 1,
  "twcny.com": 1,
  "twinstarsmail.com": 1,
  "tx.rr.com": 1,
  "tycoonmail.com": 1,
  "typemail.com": 1,
  "u14269.ml": 1,
  "u2club.com": 1,
  "ua.fm": 1,
  "uae.ac": 1,
  "uaemail.com": 1,
  "ubbi.com": 1,
  "ubbi.com.br": 1,
  "uboot.com": 1,
  "uk2.net": 1,
  "uk2k.com": 1,
  "uk2net.com": 1,
  "uk7.net": 1,
  "uk8.net": 1,
  "ukbuilder.com": 1,
  "ukcool.com": 1,
  "ukdreamcast.com": 1,
  "ukmail.org": 1,
  "ukmax.com": 1,
  "ukr.net": 1,
  "uku.co.uk": 1,
  "ultra.fyi": 1,
  "ultapulta.com": 1,
  "ultrapostman.com": 1,
  "ummah.org": 1,
  "umpire.com": 1,
  "unbounded.com": 1,
  "unforgettable.com": 1,
  "uni.de": 1,
  "unican.es": 1,
  "unihome.com": 1,
  "unitybox.de": 1,
  "universal.pt": 1,
  "uno.ee": 1,
  "uno.it": 1,
  "unofree.it": 1,
  "unterderbruecke.de": 1,
  "uol.com.ar": 1,
  "uol.com.br": 1,
  "uol.com.co": 1,
  "uol.com.mx": 1,
  "uol.com.ve": 1,
  "uole.com": 1,
  "uole.com.ve": 1,
  "uolmail.com": 1,
  "uomail.com": 1,
  "upc.nl": 1,
  "upcmail.nl": 1,
  "upf.org": 1,
  "uplipht.com": 1,
  "ureach.com": 1,
  "urgentmail.biz": 1,
  "urhen.com": 1,
  "uroid.com": 1,
  "usa.com": 1,
  "usa.net": 1,
  "usaaccess.net": 1,
  "usanetmail.com": 1,
  "used-product.fr": 1,
  "usermail.com": 1,
  "username.e4ward.com": 1,
  "usma.net": 1,
  "usmc.net": 1,
  "uswestmail.net": 1,
  "uymail.com": 1,
  "uyuyuy.com": 1,
  "v-sexi.com": 1,
  "vaasfc4.tk": 1,
  "vahoo.com": 1,
  "valemail.net": 1,
  "vampirehunter.com": 1,
  "varbizmail.com": 1,
  "vcmail.com": 1,
  "velnet.co.uk": 1,
  "velocall.com": 1,
  "verizon.net": 1,
  "verizonmail.com": 1,
  "verlass-mich-nicht.de": 1,
  "versatel.nl": 1,
  "veryfast.biz": 1,
  "veryrealemail.com": 1,
  "veryspeedy.net": 1,
  "vfemail.net": 1,
  "vickaentb.tk": 1,
  "videotron.ca": 1,
  "viditag.com": 1,
  "viewcastmedia.com": 1,
  "viewcastmedia.net": 1,
  "vinbazar.com": 1,
  "violinmakers.co.uk": 1,
  "vip.126.com": 1,
  "vip.21cn.com": 1,
  "vip.citiz.net": 1,
  "vip.gr": 1,
  "vip.onet.pl": 1,
  "vip.qq.com": 1,
  "vip.sina.com": 1,
  "vipmail.ru": 1,
  "virgilio.it": 1,
  "virgin.net": 1,
  "virginbroadband.com.au": 1,
  "virginmedia.com": 1,
  "virtualmail.com": 1,
  "visitmail.com": 1,
  "visitweb.com": 1,
  "visto.com": 1,
  "visualcities.com": 1,
  "vivavelocity.com": 1,
  "vivianhsu.net": 1,
  "vjtimail.com": 1,
  "vkcode.ru": 1,
  "vnet.citiz.net": 1,
  "vnn.vn": 1,
  "vodafone.nl": 1,
  "vodafonethuis.nl": 1,
  "volcanomail.com": 1,
  "vollbio.de": 1,
  "volloeko.de": 1,
  "vomoto.com": 1,
  "vorsicht-bissig.de": 1,
  "vorsicht-scharf.de": 1,
  "vote-democrats.com": 1,
  "vote-hillary.com": 1,
  "vote-republicans.com": 1,
  "vote4gop.org": 1,
  "votenet.com": 1,
  "vp.pl": 1,
  "vr9.com": 1,
  "vubby.com": 1,
  "w3.to": 1,
  "wahoye.com": 1,
  "walala.org": 1,
  "wales2000.net": 1,
  "walkmail.net": 1,
  "walkmail.ru": 1,
  "wam.co.za": 1,
  "wanadoo.es": 1,
  "wanadoo.fr": 1,
  "war-im-urlaub.de": 1,
  "warmmail.com": 1,
  "warpmail.net": 1,
  "warrior.hu": 1,
  "waumail.com": 1,
  "wazabi.club": 1,
  "wbdet.com": 1,
  "wearab.net": 1,
  "web-contact.info": 1,
  "web-emailbox.eu": 1,
  "web-ideal.fr": 1,
  "web-mail.com.ar": 1,
  "web-mail.pp.ua": 1,
  "web-police.com": 1,
  "web.de": 1,
  "webave.com": 1,
  "webcammail.com": 1,
  "webcity.ca": 1,
  "webcontact-france.eu": 1,
  "webdream.com": 1,
  "webindia123.com": 1,
  "webjump.com": 1,
  "webm4il.info": 1,
  "webmail.co.yu": 1,
  "webmail.co.za": 1,
  "webmail.hu": 1,
  "webmails.com": 1,
  "webname.com": 1,
  "webprogramming.com": 1,
  "webstation.com": 1,
  "websurfer.co.za": 1,
  "webtopmail.com": 1,
  "webuser.in": 1,
  "wee.my": 1,
  "weedmail.com": 1,
  "weekmail.com": 1,
  "weekonline.com": 1,
  "wefjo.grn.cc": 1,
  "weg-werf-email.de": 1,
  "wegas.ru": 1,
  "wegwerf-emails.de": 1,
  "wegwerfmail.info": 1,
  "wegwerpmailadres.nl": 1,
  "wehshee.com": 1,
  "weibsvolk.de": 1,
  "weibsvolk.org": 1,
  "weinenvorglueck.de": 1,
  "welsh-lady.com": 1,
  "westnet.com": 1,
  "westnet.com.au": 1,
  "wetrainbayarea.com": 1,
  "wfgdfhj.tk": 1,
  "whale-mail.com": 1,
  "whartontx.com": 1,
  "whatiaas.com": 1,
  "whatpaas.com": 1,
  "wheelweb.com": 1,
  "whipmail.com": 1,
  "whoever.com": 1,
  "whoopymail.com": 1,
  "whtjddn.33mail.com": 1,
  "wi.rr.com": 1,
  "wi.twcbc.com": 1,
  "wickmail.net": 1,
  "wideopenwest.com": 1,
  "wildmail.com": 1,
  "wilemail.com": 1,
  "will-hier-weg.de": 1,
  "windowslive.com": 1,
  "windrivers.net": 1,
  "windstream.net": 1,
  "wingnutz.com": 1,
  "winmail.com.au": 1,
  "winning.com": 1,
  "wir-haben-nachwuchs.de": 1,
  "wir-sind-cool.org": 1,
  "wirsindcool.de": 1,
  "witty.com": 1,
  "wiz.cc": 1,
  "wkbwmail.com": 1,
  "wmail.cf": 1,
  "wo.com.cn": 1,
  "woh.rr.com": 1,
  "wolf-web.com": 1,
  "wolke7.net": 1,
  "wollan.info": 1,
  "wombles.com": 1,
  "women-at-work.org": 1,
  "wongfaye.com": 1,
  "wooow.it": 1,
  "worker.com": 1,
  "workmail.com": 1,
  "worldemail.com": 1,
  "worldnet.att.net": 1,
  "wormseo.cn": 1,
  "wosaddict.com": 1,
  "wouldilie.com": 1,
  "wovz.cu.cc": 1,
  "wowgirl.com": 1,
  "wowmail.com": 1,
  "wowway.com": 1,
  "wp.pl": 1,
  "wptamail.com": 1,
  "wrexham.net": 1,
  "writeme.com": 1,
  "writemeback.com": 1,
  "wrongmail.com": 1,
  "wtvhmail.com": 1,
  "wwdg.com": 1,
  "www.com": 1,
  "www.e4ward.com": 1,
  "www2000.net": 1,
  "wx88.net": 1,
  "wxs.net": 1,
  "x-mail.net": 1,
  "x-networks.net": 1,
  "x5g.com": 1,
  "xagloo.com": 1,
  "xaker.ru": 1,
  "xing886.uu.gl": 1,
  "xmastime.com": 1,
  "xms.nl": 1,
  "xmsg.com": 1,
  "xoom.com": 1,
  "xoxox.cc": 1,
  "xpressmail.zzn.com": 1,
  "xs4all.nl": 1,
  "xsecurity.org": 1,
  "xsmail.com": 1,
  "xtra.co.nz": 1,
  "xuno.com": 1,
  "xww.ro": 1,
  "xy9ce.tk": 1,
  "xyzfree.net": 1,
  "xzapmail.com": 1,
  "y7mail.com": 1,
  "ya.ru": 1,
  "yada-yada.com": 1,
  "yaho.com": 1,
  "yahoo.ae": 1,
  "yahoo.at": 1,
  "yahoo.be": 1,
  "yahoo.ca": 1,
  "yahoo.ch": 1,
  "yahoo.cn": 1,
  "yahoo.co": 1,
  "yahoo.co.id": 1,
  "yahoo.co.il": 1,
  "yahoo.co.in": 1,
  "yahoo.co.jp": 1,
  "yahoo.co.kr": 1,
  "yahoo.co.nz": 1,
  "yahoo.co.th": 1,
  "yahoo.co.uk": 1,
  "yahoo.co.za": 1,
  "yahoo.com": 1,
  "yahoo.com.ar": 1,
  "yahoo.com.au": 1,
  "yahoo.com.br": 1,
  "yahoo.com.cn": 1,
  "yahoo.com.co": 1,
  "yahoo.com.hk": 1,
  "yahoo.com.is": 1,
  "yahoo.com.mx": 1,
  "yahoo.com.my": 1,
  "yahoo.com.ph": 1,
  "yahoo.com.ru": 1,
  "yahoo.com.sg": 1,
  "yahoo.com.tr": 1,
  "yahoo.com.tw": 1,
  "yahoo.com.vn": 1,
  "yahoo.cz": 1,
  "yahoo.de": 1,
  "yahoo.dk": 1,
  "yahoo.es": 1,
  "yahoo.fi": 1,
  "yahoo.fr": 1,
  "yahoo.gr": 1,
  "yahoo.hu": 1,
  "yahoo.ie": 1,
  "yahoo.in": 1,
  "yahoo.it": 1,
  "yahoo.jp": 1,
  "yahoo.nl": 1,
  "yahoo.no": 1,
  "yahoo.pl": 1,
  "yahoo.pt": 1,
  "yahoo.ro": 1,
  "yahoo.ru": 1,
  "yahoo.se": 1,
  "yahoofs.com": 1,
  "yalla.com": 1,
  "yalla.com.lb": 1,
  "yalook.com": 1,
  "yam.com": 1,
  "yandex.com": 1,
  "yandex.pl": 1,
  "yandex.ru": 1,
  "yandex.ua": 1,
  "yapost.com": 1,
  "yapped.net": 1,
  "yawmail.com": 1,
  "yeah.net": 1,
  "yebox.com": 1,
  "yehey.com": 1,
  "yemenmail.com": 1,
  "yepmail.net": 1,
  "yert.ye.vc": 1,
  "yesey.net": 1,
  "yifan.net": 1,
  "ymail.com": 1,
  "yogotemail.com": 1,
  "yomail.info": 1,
  "yopmail.com": 1,
  "yopmail.pp.ua": 1,
  "yopolis.com": 1,
  "yopweb.com": 1,
  "youareadork.com": 1,
  "youmailr.com": 1,
  "your-house.com": 1,
  "your-mail.com": 1,
  "yourinbox.com": 1,
  "yourlifesucks.cu.cc": 1,
  "yourlover.net": 1,
  "yourname.freeservers.com": 1,
  "yournightmare.com": 1,
  "yours.com": 1,
  "yourssincerely.com": 1,
  "yoursubdomain.zzn.com": 1,
  "yourteacher.net": 1,
  "yourwap.com": 1,
  "yuuhuu.net": 1,
  "yyhmail.com": 1,
  "z1p.biz": 1,
  "za.com": 1,
  "zahadum.com": 1,
  "zaktouni.fr": 1,
  "zeepost.nl": 1,
  "zetmail.com": 1,
  "zhaowei.net": 1,
  "zhouemail.510520.org": 1,
  "ziggo.nl": 1,
  "zionweb.org": 1,
  "zip.net": 1,
  "zipido.com": 1,
  "ziplip.com": 1,
  "zipmail.com": 1,
  "zipmail.com.br": 1,
  "zipmax.com": 1,
  "zmail.ru": 1,
  "zoemail.com": 1,
  "zoemail.org": 1,
  "zoho.com": 1,
  "zomg.info": 1,
  "zonnet.nl": 1,
  "zoominternet.net": 1,
  "zubee.com": 1,
  "zuvio.com": 1,
  "zuzzurello.com": 1,
  "zwallet.com": 1,
  "zweb.in": 1,
  "zxcv.com": 1,
  "zxcvbnm.com": 1,
  "zybermail.com": 1,
  "zydecofan.com": 1,
  "zzn.com": 1,
  "zzom.co.uk": 1,
  "zzz.com": 1,
  "zzz.pl": 1
}

export default freeDomains as Record<string, number>;
